export enum Agreement {
  personalInformation = 'personalInformation',
  personalInformationV2 = 'personalInformationV2',
  personalInformationEn = 'personalInformationEn',
  termsOfService = 'termsOfService',
  termsOfServiceV2 = 'termsOfServiceV2',
  termsOfServiceEn = 'termsOfServiceEn',
  informationRelease = 'informationRelease',
  sensitiveInformationRelease = 'sensitiveInformationRelease',
  thirdPartyInformationSharing = 'thirdPartyInformationSharing',
}

export const agreements: { [type in Agreement]: string } = {
  [Agreement.personalInformation]: `
<meta name="viewport" content="width=device-width user-scalable=0 initial-scale=1.0 mximum-scale=1.0 minimum-scale=1.0">
  <style>
ul, ol {
  padding-left: 2em;
}
ol ol ol {
  padding-left: 1em;
}
h1 {
  font-size: 20px;
}
h2 {
  font-size: 14px;
}
th, td, p, li {
  font-size: 12px;
}
table, th, td {
  border-collapse: collapse;
  border: 1px solid;
}
  </style>
<!-- <h1 style="text-align: center;">개인정보처리방침</h1> -->
<p>&nbsp;본 기관은 개인정보보호법 등, 관계 법률에 따라서 이용자의 개인정보 보호 및 권익을 보호하고, 개인정보와 관련한 이용자의 고충을 원활하게 처리할 수 있도록 다음과 같은 처리방침을 두고 있음을 알려드립니다.</p>
<h2>제1조 개인정보의 처리목적</h2>
<p>본 기관은 다음 각 호의 목적을 위해 필요&middot;최소한의 개인정보를 처리합니다. 개인정보는 다음의 목적 외의 용도로는 사용되지 않으며, 이용 목적이 변경되는 경우에는 별도의 동의를 받는 등, 필요한 조치를 이행할 예정입니다.</p>
<ol>
  <li>
    회원 가입 및 관리
    <br>&nbsp;회원가입, 가입회원 서비스 제공, 본인확인, 개인식별, 비인가 사용방지, 서비스 부정이용 방지 등.
  </li>
  <li>
    서비스 제공
    <br>&nbsp;건강 컨텐츠 등의 정보 제공, 제품문의 등을 위한 서비스 제공, 제품 또는 서비스의 홍보 등의 마케팅 활동, 이메일 발송 등의 각종 고지 통지, 계약서 청구서 발송, 요금결제 정산, 뉴스레터 등의 기타 맞춤 서비스 제공.
  </li>
  <li>
    교육&middot;연구 및 통계
    <br>&nbsp;연구활동, 교육활동 및 서비스 이용에 대한 통계 등.
  </li>
  <li>
    민원처리 및 안전성정보 관리
    <br>&nbsp;제품관련 문의에 대한 응답, 민원인의 신원 확인, 민원사항 확인 사실조사를 위한 연락 및 통지, 처리결과 통보, 제품의 안전성정보와 품질불만의 보고, 평가 및 관리 등.
  </li>
  <li>
    가명정보의 처리
    <br>&nbsp;상업적 목적을 포함한 통계작성, 과학적 연구, 공익적 기록보존 목적 등을 위한 가명정보 처리.
  </li>
</ol>
<h2>제2조 처리하는 개인정보의 항목 및 수집방법</h2>
<ol>
  <li>
    수집항목
    <br>&nbsp;본 기관은 다음의 개인정보 항목을 처리하고 있습니다.
  </li>
  <ol>
    <li style="list-style: '가. ';">필수 수집항목
      <ol>
        <li style="list-style: '1) ';">아이디(휴대전화번호 또는 email), 비밀번호</li>
        <li style="list-style: '2) ';">환자 기본 정보(이름, 전화번호, 성별, 나이 등)</li>
        <li style="list-style: '3) ';">건강검진 정보(키, 몸무게, 시력, 혈압 등)</li>
        <li style="list-style: '4) ';">병원/약국 방문정보</li>
        <li style="list-style: '5) ';">병원/약국 투약정보</li>
        <li style="list-style: '6) ';">의료영상 정보</li>
      </ol>
    </li>
    <li style="list-style: '나. ';">선택 수집항목
      <ol>
        <li style="list-style: '1) ';">해당없음</li>
      </ol>
    </li>
    <li style="list-style: '다. ';">자동으로 수집하는 항목
      <ol>
        <li style="list-style: '1) ';">서비스 이용기록, 접속 로그, 쿠키, 접속 IP 정보</li>
      </ol>
    </li>
  </ol>
  <li>
    수집방법
    <br>&nbsp;본 기관은 다음과 같은 방법으로 개인정보를 수집하고 있습니다.
  </li>
  <ol>
    <li style="list-style: '가. ';">이용자가입 및 서비스 이용과정에서 이용자가 개인정보 수집에 대해 동의하고 직접 입력</li>
    <li style="list-style: '나. ';">서비스 이용 과정에서 이용자가 조회서비스를 이용하여 해당 기관으로부터 자료를 조회하는 방법</li>
    <li style="list-style: '다. ';">이용자의 동의에 따라, 휴대폰 문자메시지, 모바일 어플리케이션 푸쉬 알림 등을 통하여 읽어오는 방법</li>
    <li style="list-style: '라. ';">고객이 서비스 내에서 설문 응답 등을 통해 직접입력</li>
    <li style="list-style: '마. ';">쿠키정보와 같은 생성정보의 경우 동의 시 PC웹, 모바일웹, 앱 이용과정에서 자동 생성</li>
  </ol>
</ol>
<h2>제3조 개인정보의 제3자 제공</h2>
<p>본 기관은 원칙적으로 정보주체의 개인정보를 제1조(개인정보의 처리목적)에서 명시한 범위 내에서 처리하며, 정보주체의 사전 동의 없이는 제3자에게 제공하지 않습니다. 단, 다음의 경우에는 개인정보를 목적 외의 용도로 이용하거나 제3자에게 제공할 수 있습니다.</p>
<ol>
  <li>정보주체가 사전에 제3자 제공 및 공개에 동의한 경우.</li>
  <li>법률에 특별한 규정이 있거나 법령상 의무를 준수하기 위하여 불가피한 경우.</li>
  <li>정보주체 또는 그 법정대리인이 의사표시를 할 수 없는 상태에 있거나 주소불명 등으로 사전 동의를 받을 수 없는 경우로서 명백히 당사자 또는 제3자의 급박한 생명 신체 재산의 이익을 위하여 필요하다고 인정되는 경우.</li>
  <li>통계작성 학술연구 또는 시장조사를 위하여 필요한 경우로서 특정 개인을 알아볼 수 없는 형태로 개인정보를 제공하는 경우.</li>
  <li>통계작성, 과학적 연구, 공익적 기록보존 목적 등을 위해 가명처리하여 제공하는 경우.</li>
</ol>
<h2>제4조 개인정보처리의 위탁</h2>
<ol>
  <li>
    본 기관은 원활한 개인정보 업무처리를 위해서 아래와 같이 개인정보 처리업무를 외부기관에 위탁하고 있습니다.
    <p>
    <table style="border-collapse: collapse; width: 650px;" border="1">
      <tbody>
        <tr>
          <th width="36">No. </th>
          <th width="141">제공목적</th>
          <th width="103">제공업체</th>
          <th width="228">개인정보 제공항목</th>
          <th width="142">이용 및 보유기간</th>
        </tr>
        <tr>
          <td width="36">1</td>
          <td width="141">
            가명정보 처리<br>
            맞춤형 의학정보 수집
          </td>
          <td width="103" style="text-align: center;">㈜헬스허브</td>
          <td>
            <ul>
              <li>아이디(휴대전화번호), 비밀번호</li>
              <li>환자 기본 정보(이름, 전화번호, 성별, 나이 등)</li>
              <li>건강검진 정보(키, 몸무게, 시력, 혈압 등)</li>
              <li>병원/약국 방문정보</li>
              <li>병원/약국 투약정보</li>
              <li>의료영상 정보</li>
            </ul>
          </td>
          <td width="142">계약 종료 시까지</td>
        </tr>
      </tbody>
    </table>
    </p>
  </li>
  <li>본 기관은 위탁계약 체결 시 개인정보보호법 제26조에 따라 위탁업무 수행목적 외 개인정보 처리금지, 기술적/관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.</li>
</ol>
<h2>제5조 개인정보의 안전성 확보조치에 관한 사항</h2>
<ol>
  <li>개인정보 취급 직원의 최소화 및 교육
    <br>개인정보취급자의 지정을 최소화하고 정기적인 교육을 시행하고 있습니다.
  </li>
  <li>정기적인 자체 감사 실시
    <br>개인정보 취급 관련 안정성 확보를 위해 연 1회 이상 정기적으로 자체 감사를 실시하고 있습니다.
  </li>
  <li>내부관리계획의 수립 및 시행
    <br>개인정보의 안전한 처리를 위하여 내부관리계획을 수립하고 시행하고 있습니다.
  </li>
  <li>개인정보의 암호화
    <br>이용자의 개인정보 중 비밀번호는 암호화 되어 저장 및 관리되고 있어 본인만이 알 수 있으며 중요한 데이터는 파일 및 전송 데이터를 암호화 하는 등의 별도 보안기능을 사용하고 있습니다.
  </li>
  <li>해킹 등에 대비한 기술적 대책
    <br>해킹이나 컴퓨터 바이러스 등에 의한 개인정보 유출 및 훼손을 막기 위하여 보안프로그램을 설치하고 주기적인 갱신, 점검을 하며 외부로부터 접근이 통제된 구역에 시스템을 설치하고 기술적/물리적으로 감시 및 차단하고 있습니다.
  </li>
  <li>개인정보에 대한 접근 제한
    <br>개인정보를 처리하는 데이터베이스시스템에 대한 접근권한의 부여, 변경, 말소를 통하여 개인정보에 대한 접근통제를 위하여 필요한 조치를 하고 있으며 침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있습니다.
  </li>
  <li>접속기록의 보관 및 위변조 방지
    <br>개인정보처리시스템에 접속한 기록을 최소 6개월 이상 보관, 관리하고 있으며, 접속 기록이 위변조 및 도난, 분실되지 않도록 보안기능을 사용하고 있습니다.
  </li>
  <li>비인가자에 대한 출입 통제
    <br>개인정보를 보관하고 있는 개인정보시스템의 물리적 보관 장소를 별도로 두고 이에 대해 출입통제 절차를 수립, 운영하고 있습니다.
  </li>
</ol>
<h2>제6조 개인정보의 처리 및 보유기간</h2>
<ol>
  <li>본 기관은 개인정보 수집 시 정보주체가 동의한 기간 동안 개인정보를 보유합니다. 단, 관련 법규에 의하여 보존할 필요성이 있는 경우에는 해당 법규에서 정한 기간 동안 개인정보를 보유합니다.</li>
  <li>본 기관은 회원이 탈회하거나 회원을 제명하는 경우 권리남용방지, 악용방지, 각종 분쟁대비 및 법규상 의무이행을 위하여 이용계약 해지일로부터 5년 동안 개인정보 보존합니다.</li>
  <li>본 기관은 다음의 정보에 대해서는 아래 명시한 기간 동안 보존합니다.
    <ul>
      <li style="list-style: '가. ';">결제 및 서비스 등의 공급에 관한 기록: 5년.</li>
      <li style="list-style: '나. ';">계약 또는 청약철회 등에 관한 기록: 5년.</li>
      <li style="list-style: '다. ';">민원관련 정보 안전성정보 및 품질불만: 3년.</li>
      <li style="list-style: '라. ';">분쟁처리에 관한 기록: 3년.</li>
      <li style="list-style: '마. ';">설문조사 등의 목적을 위하여 수집한 경우: 당해 설문조사 등이 종료한 때.</li>
    </ul>
  </li>
</ol>
<h2>제7조 개인정보 수집&middot;이용에 대한 거부 권리 및 거부 시 불이익</h2>
<ol>
  <li>정보주체는 개인정보 수집, 이용에 대한 동의를 거부할 권리가 있습니다. 단, 동의를 거부할 경우 서비스 이용에 제한이 있을 수 있습니다.</li>
  <li>개인정보 자동 수집 장치의 설치&middot;운영 및 그 거부에 관한 사항<br />본 기관은 정보주체의 사용자 인증 또는 맞춤서비스 제공을 위하여&lsquo;쿠키&rsquo;를 이용하고 있습니다. 쿠키는 이용자 사이트에 대한 기본 설정정보를 보관하기 위해 해당 웹사이트가 이용자의 컴퓨터 브라우저에 전송하는 소량의 정보입니다. 정보주체는 정보주체의 웹 브라우저에서 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부할 수 있는 선택권이 있습니다. 단, 쿠키 저장을 거부할 경우에는 서비스 이용에 제한이 있을 수 있습니다. [참고] 이용자가 사용하는 각각의 브라우저는 해당 브라우저의 쿠키 설정방법에 따릅니다.</li>
</ol>
<h2>제8조 개인정보의 파기</h2>
<ol>
  <li>본 기관은 개인정보의 보유기간이 경과된 경우 또는 개인정보의 처리 목적 달성, 해당 서비스의 폐지, 사업의 종료 등, 그 개인정보가 불필요하게 되었을 때에는 지체 없이 해당 개인정보를 파기합니다. 단, 상법 등 관련 법규 및 내부방침에 따라 보존하여야 하는 경우에는 파기하지 아니 합니다.</li>
  <li>개인정보가 기록된 출력물 서면 등은 파쇄 또는 소각의 방법으로 파기하고, 전자적 파일 형태의 개인정보는 복원이 불가능한 방법으로 영구 삭제 파기합니다.</li>
</ol>
<h2>제9조 정보주체와 법정대리인의 권리&middot;의무 및 그 행사방법</h2>
<ol>
  <li>개인정보의 열람
    <br>정보주체는 본 기관을 방문하여 개인정보의 열람을 요구할 수 있으며, 신속하게 이에 대하여 응대합니다.
  </li>
  <li>개인정보의 정정ㆍ삭제
    <br>본 기관은 정보주체가 개인정보에 대한 정정ㆍ삭제를 요구하는 경우, 개인정보에 오류가 있다고 판명되는 등, 정정ㆍ삭제를 할 필요가 있다고 인정되는 경우에는 지체 없이 정정ㆍ삭제를 합니다. 처리의 정확성을 위하여 본 기관은 정보주체에게 정정ㆍ삭제 내용의 사실 확인에 필요한 증빙자료를 요청할 수 있습니다.
  </li>
  <li>행사방법
    <ul>
      <li style="list-style: '가. ';">본 기관은 정보주체가 개인정보에 대한 열람 정정 및 삭제를 요구하는 경우에는 정보주체의 요구에 성실하게 응대하고 지체 없이 처리합니다. 정보주체의 개인정보를 엄격히 보호하기 위하여 정보주체의 방문 이외의 전화ㆍ우편ㆍFAX 등, 기타 신청방법에 의한 정보주체의 개인정보의 열람 정정 및 삭제 절차는 제공하지 않습니다.</li>
      <li style="list-style: '나. ';">정보주체가 개인정보에 대한 열람 정정 및 삭제를 요구하는 경우, 정보주체의 신분을 나타내는 주민등록증, 여권, 운전면허증 등의 신분증명서를 제시 받아 본인 여부를 확인합니다.</li>
      <li style="list-style: '다. ';">정보주체의 대리인이 방문하여 열람 정정 및 삭제를 요구하는 경우에는 정보주체의 위임장 및 동의서와 대리인의 신분증명서 등을 확인하여 정당한 대리인인지 여부를 확인합니다.</li>
      <li style="list-style: '라. ';">본 기관은 법률에 특별한 규정이 있거나 법령상 의무를 준수하기 위하여 부가피한 경우 등, 개인정보의 전부 또는 일부에 대하여 열람 정정 및 삭제를 거절할 정당한 이유가 있는 경우에는 정보주체의 요구를 거절할 수 있으며, 이 경우, 정보주체에게 이를 통지하고 그 사유를 알려 드립니다.</li>
    </ul>
  </li>
</ol>
<h2>제10조 개인정보 보호책임자</h2>
<ol>
  <li>본 기관은 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.
    <ul style="list-style: '▶';">
      <li>개인정보 보호책임자: 변시섭 연구소장(CTO)
      <li>개인정보 보호 담당부서: 연구개발기획팀
      <li>전화: 02-511-3601
      <li>Email: hh-planning@healthhub.kr
    </ul>
  </li>
  <li>본 기관의 서비스를 이용하시면서 발생한 개인정보 보호관련 모든 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의하실 수 있습니다.</li>
</ol>
<h2>제11조 권익침해 구제방법</h2>
<p>본 기관 외의 개인정보 침해로 인한 신고나 상담이 필요하신 경우, 아래 기관에 문의하시기 바랍니다.</p>
<ul style="list-style: '▶';">
  <li>개인정보보호 포털(<a href="http://www.privacy.go.kr">privacy.go.kr</a> / 국번없이 118)</li>
  <li>한국인터넷진흥원 개인정보침해신고센터(privacy.kisa.or.kr / 국번없이 118)</li>
  <li>경찰청 사이버수사국(ecrm.cyber.go.kr / 국번없이 112, 182)</li>
</ul>
<h2>제12조 개인정보 처리방침 변경</h2>
<ol>
  <li>본 개인정보처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경 내용의 추가 삭제 및 수정이 있을 경우에는 변경사항의 시행 7일 전부터 공지사항을 통하여 고지하겠습니다.</li>
  <li>본 개인정보처리방침의 변경 내역은 아래와 같습니다.
    <ul style="list-style: '▶';">
      <li>제정 일자: 2022년 3월 21일</li>
      <li>개정 일자:</li>
      <li>시행 일자: 2022년 3월 21일</li>
    </ul>
  </li>
</ol>
  `,
  [Agreement.termsOfService]: `
<meta name="viewport" content="width=device-width user-scalable=0 initial-scale=1.0 mximum-scale=1.0 minimum-scale=1.0">
<style>
ol {
  padding-left: 1em;
}
ol ol {
  padding-left: 1em;
}
h1 {
  font-size: 20px;
}
h2 {
  font-size: 11px;
}
p, li {
  font-size: 11px;
}
</style>
<!-- <h1>이용약관</h1> -->
<p>헬스허브(이하 &quot;회사&quot;라 합니다)는 HSCAN 서비스(이하 &quot;서비스&quot;라 합니다)를 제공함에 있어 HScan 이용약관(이하 &quot;본 약관&quot;이라 합니다)을 적용합니다. 서비스를 이용함으로써 귀하는 본 약관에 동의하게 되므로 본 약관을 주의 깊게 읽어보시기 바랍니다.</p>
<h2>제1조 (목적)</h2>
<ol>
  <li style="list-style: '① ';">본 약관은 이용자가 &quot;회사&quot;에서 제공하는 &quot;서비스&quot;를 이용함에 있어 이용자와 &quot;회사&quot;의 권리&middot;의무 및 책임사항을 규정함을 목적으로 합니다.</li>
  <li style="list-style: '② ';">이용자가 되고자 하는 자가 &quot;회사&quot;가 정한 소정의 절차를 거쳐서 &quot;동의&quot; 단추를 누르면 본 약관에 동의하는 것으로 간주합니다. 본 약관에 정하는 이외의 이용자와 &quot;회사&quot;의 권리, 의무 및 책임사항에 관해서는 대한민국의 관련 법령과 상관습에 의합니다.</li>
</ol>
<h2>제2조 (정의)</h2>
<ol>
  <li style="list-style: '① ';">이용자(회원) : 인터넷 홈페이지에 로그인하여 본 약관에 따라 회사가 제공하는 서비스를 받는 자를 말합니다.</li>
  <li style="list-style: '② ';">운영자 : 서비스의 전반적인 관리와 원활한 운영을 위하여 회사에서 선정한 사람</li>
  <li style="list-style: '③ ';">연결사이트 : 홈페이지와 하이퍼링크 방식(하이퍼링크의 대상에는 문자, 정지 및 동화상 등이 포함됨) 등으로 연결된 웹 사이트를 말합니다.</li>
  <li style="list-style: '④ ';">개인정보 : 당해 정보에 포함되어 있는 성명 등의 사항에 의하여 특정 개인을 식별할 수 있는 정보(당해 정보만으로는 특정 개인을 인식할 수 없더라도 다른 정보와 용이하게 결합하여 식별할 수 있는 것을 포함한다)를 말합니다.</li>
  <li style="list-style: '⑤ ';">해지 : 이용자가 서비스 개통 후 이용계약을 해약하는 것</li>
</ol>
<h2>제3조 (약관의 게시 및 변경)</h2>
<ol>
  <li style="list-style: '① ';">회사는 본 약관의 내용과 상호, 소재지, 전자우편 주소 등을 이용자가 알 수 있도록 홈페이지에 게시합니다.</li>
  <li style="list-style: '② ';">회사는 불가피한 사정이 있는 경우 관계법령을 위배하지 않는 범위에서 본 약관을 개정할 수 있습니다.</li>
  <li style="list-style: '③ ';">회사는 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행약관과 함께 서비스화면에 그 적용일자 7일 이전부터 적용일자 전일까지 공지합니다.</li>
  <li style="list-style: '④ ';">이 약관에서 정하지 아니한 사항과 이 약관의 해석에 관하여는 관계법령 또는 상관례에 따릅니다.</li>
</ol>
<h2>제4조 (서비스의 내용 및 변경)</h2>
<ol>
  <li style="list-style: '① ';">회사는 다음의 서비스를 제공합니다.
    <ol>
      <li>의료영상 업로드</li>
      <li>의료영상 공유</li>
      <li>의료영상 보관</li>
      <li>의료영상 열람</li>
      <li>의료영상을 활용한 부가서비스</li>
      <li>기타 회사가 정하는 서비스</li>
    </ol>
  </li>
  <li style="list-style: '② ';">회사는 불가피한 사정이 있는 경우 제공하는 서비스의 내용을 변경할 수 있으며, 이 경우 변경된 서비스의 내용 및 제공일자를 명시하여 그 제공일자 이전 7일부터 공지합니다.</li>
  <li style="list-style: '③ ';">회사는 서비스 내용의 변경으로 인하여 이용자가 입은 손해에 대하여 배상하지 아니합니다. 단, 회사의 고의 또는 중과실이 있는 경우에는 그러하지 아니합니다.</li>
</ol>
<h2>제5조 (서비스의 중단)</h2>
<ol>
  <li style="list-style: '① ';">회사는 시스템 등 장치의 보수점검&middot;교체 및 고장, 통신의 두절, 기타 불가항력적 사유가 발생한 경우에는 서비스의 제공을 일시적으로 중단할 수 있습니다.</li>
  <li style="list-style: '② ';">회사는 제1항의 사유로 서비스 제공이 일시적으로 중단됨으로 인하여 이용자 또는 제3자가 입은 손해에 대하여는 배상하지 아니합니다. 단, 회사의 고의 또는 중과실이 있는 경우에는 그러하지 아니합니다.</li>
</ol>
<h2>제6조 (회원가입)</h2>
<ol>
  <li style="list-style: '① ';">이용자는 회사가 정한 양식에 따라 회원정보를 기입한 후 본 약관에 동의한다는 의사표시를 함으로써 회원가입을 신청합니다.</li>
  <li style="list-style: '② ';">회사는 전항과 같이 회원으로 가입할 것을 신청한 이용자 중 이하 각호에 해당하지 않는 한 회원으로 등록합니다.
    <ol>
      <li>가입신청자가 본 약관 제7조 제2항에 의거하여 이전에 회원 자격을 상실한 적이 있는 경우</li>
      <li>등록내용에 허위, 기재누락, 오기가 있는 경우</li>
      <li>기타 회원으로 등록하는 것이 회사의 기술상 또는 업무 수행상 현저히 지장이 있다고 판단하는 경우</li>
      <li>입력한 비밀번호가 8자 이상이 아닌 경우</li>
    </ol>
  </li>
  <li style="list-style: '③ ';">회원가입계약의 성립시기는 회사가 승낙한 시점으로 합니다.</li>
  <li style="list-style: '④ ';">회원은 등록사항에 변경이 있는 경우, 즉시 전자우편 또는 기타 방법으로 회사에 그 변경사항을 알려야 합니다.</li>
</ol>
<h2>제7조 (회원 탈퇴 및 자격의 상실등)</h2>
<ol>
  <li style="list-style: '① ';">회원은 회사에 언제든지 탈퇴를 요청할 수 있으며 회사는 즉시 회원탈퇴를 처리합니다. 회원탈퇴는 홈페이지에서 로그인 후 개인정보수정에서 가능하시며 탈퇴 즉시 귀하의 개인정보를 파기하는 등 필요한 조치를 하겠습니다.</li>
  <li style="list-style: '② ';">회원이 다음 각호의 사유에 해당하는 경우, 회사는 회원자격을 상실시킬 수 있습니다.
    <ol>
      <li>등록 신청 시에 허위 내용을 등록한 경우</li>
      <li>다른 사람의 서비스 이용을 방해하거나 그 정보를 도용하는 등 질서를 위협하는 경우</li>
      <li>서비스 내에서 검증되지 않은 허위정보 및 기타 허락되지 않은 물품의 판매 행위를 하는 경우</li>
      <li>서비스 내에서 허락되지 않은 진료행위 또는 진료행위를 위한 선전의 장소로 이용하는 경우</li>
      <li>서비스 내에 제공되는 정보를 변경하는 등 홈페이지 운영을 방해한 경우</li>
      <li>서비스를 이용하여 법령과 본 약관이 금지하거나 공서양속에 반하는 행위를 하는 경우</li>
      <li>본 약관을 위반한 경우</li>
      <li>기타 회원으로서의 자격을 지속시키는 것이 부적절하다고 판단되는 경우</li>
    </ol>
  </li>
</ol>
<h2>제8조 (회원에 대한 통지)</h2>
<ol>
  <li style="list-style: '① ';">회사는 회원에 대한 통지를 하는 경우, 회원이 회사에 제공한 전자우편 주소 또는 전화번호로 할 수 있습니다.</li>
  <li style="list-style: '② ';">회사는 불특정다수 회원에 대한 통지의 경우 홈페이지에 게시함으로써 개별통지에 갈음할 수 있습니다.</li>
</ol>
<h2>제9조 (개인정보의 수집)</h2>
<ol>
  <li style="list-style: '① ';">회사는 이용자의 정보수집시 필요한 최소한의 정보를 수집합니다. 다음 사항을 필수 사항으로 하며 그 외 사항은 선택사항으로 합니다.
    <ol>
      <li>핸드폰번호</li>
      <li>전자우편 주소</li>
      <li>비밀번호</li>
    </ol>
  </li>
  <li style="list-style: '② ';">이용자의 개인정보를 수집하는 때에는 이하 각호의 경우를 제외하고는 당해 이용자의 동의를 받습니다.
    <ol>
      <li>법률에 특별한 규정이 있는 경우</li>
      <li>서비스이용계약의 이행을 위해서 필요한 경우</li>
      <li>서비스의 제공에 따른 요금정산을 위하여 필요한 경우</li>
    </ol>
  </li>
  <li style="list-style: '③ ';">회사는 개인정보의 보호를 위하여 관리자를 한정하여 그 수를 최소화하며 개인정보의 분실, 도난, 유출, 변조되지 아니하도록 안정성 확보에 필요한 기술적 조치 등을 강구합니다.</li>
  <li style="list-style: '④ ';">회사는 개인정보의 수집목적을 달성한 때에는 당해 개인정보를 지체없이</li>
</ol>
<h2>제10조(개인정보의 관리책임자)</h2>
<ol>
  <li>소속 : 헬스허브 기업부설연구소 변시섭</li>
  <li>전화번호: 02-511-3601</li>
  <li>메일: terry.byon@healthhub</li>
</ol>
<h2>제11조(개인정보의 수집목적 및 이용목적)</h2>
<ol>
  <li>이용자에게 원활한 서비스 제공을 위한 온라인 및 오프라인에서의 공지기능</li>
  <li>사용자 인증 절차 및 서비스 제공</li>
  <li>서비스 원활한 운영 및 통계분석자료로 활용</li>
</ol>
<h2>제12조(개인정보의 보유기간 및 이용기간)</h2>
<p>회사는 회원 자격을 가지고 있는 기간을 개인정보의 보유기간 및 이용기간으로 정합니다.</p>
<h2>제13조(개인정보의 이용 및 제공의 제한)</h2>
<ol>
  <li style="list-style: '① ';">제공된 개인정보는 당해 이용자의 동의없이 목적 외 이용이나 제3자에게 제공할 수 없으며, 이에 따른 이용자의 피해에 대한 모든 책임은 회사가 집니다. 단, 다음의 경우에는 예외로 합니다.
    <ol>
      <li>법률에 특별한 규정이 있는 경우</li>
      <li>서비스의 제공에 따른 요금정산 및 배송 등을 위하여 필요한 경우</li>
      <li>통계작성&middot;학술연구 또는 시장조사를 위하여 필요한 경우로서 특정 개인을 식별할 수 없는 형태로 제공하는 경우</li>
    </ol>
  </li>
  <li style="list-style: '② ';">정보통신서비스제공자로부터 이용자의 개인정보를 제공받은 자는 당해 이용자의 동의가 있거나 다른 법률에 특별한 규정이 있는 경우를 제외하고는 개인정보를 제공받은 목적 외의 용도로 이를 이용하거나 제3자에게 제공하여서는 안됩니다.</li>
</ol>
<h2>제14조(이용자의 권리)</h2>
<ol>
  <li style="list-style: '① ';">이용자는 언제든지 제9조 제2항, 제14조 제1항 또는 동조 제2항의 규정에 의한 동의를 철회할 수 있습니다. 단, 철회의 의사표시는 회사 또는 회사로부터 정보를 제공받은 자에게 전자우편이 도달된 때로부터 유효합니다.</li>
  <li style="list-style: '② ';">이용자는 회사에게 자신의 개인정보에 대한 열람을 요구할 수 있으며, 자신의 개인정보에 오류가 있는 경우에는 그 정정을 요구할 수 있습니다.</li>
  <li style="list-style: '③ ';">제1항 및 제2항에 의한 철회, 열람, 정정의 요구는 회사에 전자우편을 보내는 방식으로 하여야 하며, 회사는 전자우편이 도달된 후 지체없이 필요한 조치를 취할 의무를 집니다. 이용자가 오류의 정정을 요구한 경우에는 회사가 그 오류를 정정할 때까지 당해 개인정보를 이용하지 않습니다.</li>
</ol>
<h2>제15조 (건강관련정보 제공 서비스)</h2>
<ol>
  <li style="list-style: '① ';">회사에서 제공하는 건강관련정보는 개략적이며 일반적인 것으로서 특정인의 의견에 지나지 않으며 어떠한 경우에도 전문적인 의학적 진단, 진료, 치료를 대신할 수 없습니다.</li>
  <li style="list-style: '② ';">회사는 건강관련정보제공서비스에서 언급된 어떠한 특정한 검사나 제품 또는 치료법을 보증하지 않습니다.</li>
  <li style="list-style: '③ ';">회사는 제공하는 건강관련정보는 전적으로 이용자의 판단에 따라 이용되는 것으로서, 회사는 건강관련정보의 제공과 관련하여 어떠한 책임도 지지 않습니다.</li>
</ol>
<h2>제16조 (회사와 연결 사이트간의 관계)</h2>
<p>회사는 연결 사이트가 독자적으로 제공하는 재화, 용역, 서비스에 의하여 이용자와 행하는 거래에 대해서 어떠한 보증책임을 지지 않습니다.</p>
<h2>제17조 (회사의 의무)</h2>
<ol>
  <li style="list-style: '① ';">회사는 법령과 본 약관이 금지하거나 공서양속에 반하는 행위를 하지 않으며 본 약관이 정하는 바에 따라 지속적이고, 안정적으로 서비스를 제공하는 데 최선을 다합니다.</li>
  <li style="list-style: '② ';">회사는 이용자의 신용정보를 포함한 개인신상정보의 보안에 대하여 기술적 안전 조치를 강구하고 관리에 만전을 기함으로써 이용자의 정보보안에 최선을 다합니다.</li>
  <li style="list-style: '③ ';">회사는 공정하고 건전한 운영과 지속적인 연구&middot;개발을 통하여 양질의 서비스를 제공함으로써 고객만족을 극대화 하여 인터넷 비즈니스 발전에 기여하도록 합니다.</li>
  <li style="list-style: '④ ';">회사는 이용자가 원하지 않는 영리목적의 광고성 전자우편을 발송하지 않습니다.</li>
</ol>
<h2>제18조 (이용자의 비밀번호에 대한 의무)</h2>
<ol>
  <li style="list-style: '① ';">이용자는 서비스를 이용하는 경우 비밀번호를 사용해야 합니다.</li>
  <li style="list-style: '② ';">비밀번호에 관한 모든 관리의 책임은 이용자에게 있습니다.</li>
  <li style="list-style: '③ ';">이용자는 자신의 비밀번호를 제3자에게 이용하게 해서는 안됩니다.</li>
  <li style="list-style: '④ ';">이용자의 비밀번호의 관리의 부실로 인한 모든 책임은 이용자가 부담합니다.</li>
  <li style="list-style: '⑤ ';">이용자는 비밀번호를 도난당하거나 제3자에게 사용되고 있음을 인지한 경우에는 바로 회사에 통보하고 회사의 안내가 있는 경우에는 그에 따라야 합니다.</li>
</ol>
<h2>제19조 (이용자의 의무)</h2>
<ol>
  <li style="list-style: '① ';">이용자는 다음의 행위를 하여서는 안됩니다.
    <ol>
      <li>신청 또는 변경 시 허위내용의 등록</li>
      <li>회사에 게시된 정보의 변경</li>
      <li>회사가 정한 정보 이외의 정보(컴퓨터프로그램 등)의 송신 또는 게시</li>
      <li>회사 기타 제3자의 저작권 등 지적재산권에 대한 침해</li>
      <li>회사 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위</li>
      <li>외설 또는 폭력적인 메시지&middot;화상&middot;음성 기타 공서양속에 반하는 정보를 회사에 공개 또는 게시하는 행위</li>
      <li>다른 이용자에 대한 건강진료 및 상담을 하거나 알선하는 행위</li>
      <li>제3자의 진료행위를 선전하는 행위</li>
      <li>상품을 판매하거나 판매를 알선하는 행위</li>
      <li>기타 부적절하다고 판단하는 행위</li>
    </ol>
  </li>
  <li style="list-style: '② ';">전항 각호의 정보 또는 기타 회사 사이트 운영상 부적절하다고 판단한 정보가 홈페이지에 게시되거나 사이트와 링크된 곳에 게시된 경우, 회사는 이용자 또는 기타 정보의 게시를 행한 자의 승낙없이 홈페이지에 게재된 당해 정보를 삭제하거나 링크를 단절할 수 있습니다. 단, 회사는 이러한 정보의 삭제&middot;링크의 절단 등을 할 의무를 지지 않습니다.</li>
</ol>
<h2>제20조 (저작권의 귀속 및 이용제한)</h2>
<ol>
  <li style="list-style: '① ';">회사가 작성한 저작물에 대한 저작권 기타 지적재산권은 회사에 귀속합니다.</li>
  <li style="list-style: '② ';">이용자는 홈페이지를 이용함으로써 얻은 정보를 회사의 사전 승낙 없이 복제, 송신, 출판, 배포, 방송 기타 방법에 의하여 영리목적으로 이용하거나 제3 자에게 이용하게 하여서는 안됩니다.</li>
</ol>
<h2>제21조 (분쟁해결)</h2>
<ol>
  <li style="list-style: '① ';">본 이용약관에 규정된 것을 제외하고 발생하는 서비스 이용에 관한 제반 문제에 관한 분쟁은 최대한 쌍방합의에 의해 해결하도록 합니다.</li>
  <li style="list-style: '② ';">이용자가 홈페이지 이용과 관련하여 불만이 있거나 의견을 제시하고자 하는 경우에는 전자우편으로 홈페이지에 대한 불만사항 또는 의견을 제출하면 됩니다.</li>
  <li style="list-style: '③ ';">회사는 이용자로부터 제출되는 불만사항 및 의견이 정당하다고 판단하는 경우 우선적으로 그 사항을 처리합니다. 다만, 신속한 처리가 곤란한 경우에는 이용자에게 그 사유와 처리일정을 즉시 통보해 드립니다.</li>
</ol>
<h2>제22조 (재판권 및 준거법)</h2>
<ol>
  <li style="list-style: '① ';">회사와 이용자간에 서비스 이용으로 발생한 분쟁에 관한 소송은 민사소송법상의 관할법원으로 합니다.</li>
  <li style="list-style: '② ';">회사와 이용자간에 제기된 전자거래 소송에는 대한한국법을 적용합니다.</li>
</ol>
  `,
  [Agreement.informationRelease]: `
<meta name="viewport" content="width=device-width user-scalable=0 initial-scale=1.0 mximum-scale=1.0 minimum-scale=1.0">
<style>
h1 {
  font-size: 20px;
}
h2 {
  font-size: 11px;
}
p, li, th, td {
  font-size: 11px;
}
table, th, td {
  border-collapse: collapse;
  border: 1px solid;
}
</style>
<!-- <h1>개인정보 수집&middot;이용 동의서</h1> -->
<p>
헬스허브는 서비스 제공을 위하여 아래와 같이 개인정보를 수집&middot이용 및 제공 하고자 합니다.
내용을 자세히 읽으신 후 동의 여부를 결정하여 주십시오.
</p>

<h2>개인 정보 수집&middot;이용 동의(필수)</h2>
<table>
  <thead>
    <tr>
      <th width="40%">항목</th>
      <th width="42%">수집목적</th>
      <th width="18%">보유기간</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>아이디(휴대전화번호), 비밀번호, 기본 정보(이름, 전화번호, 성별, 나이)</td>
      <td>회원 가입 및 부정사용 방지<br>앱 서비스 제공</td>
      <td>계약 종료시까지</td>
    </tr>
  </tbody>
</table>
<p>위의 개인정보 수집&middot;이용에 대한 동의를 거부할 권리가 있습니다. 그러나 동의를 거부할 경우 원활한 서비스 제공에 일부 제한을 받을 수 있습니다.</p>
<p>위와 같이 개인정보를 수집&middot;이용하는데 동의하십니까?</p>
  `,
  [Agreement.sensitiveInformationRelease]: `
<meta name="viewport" content="width=device-width user-scalable=0 initial-scale=1.0 mximum-scale=1.0 minimum-scale=1.0">
<style>
h1 {
  font-size: 20px;
}
h2 {
  font-size: 11px;
}
p, li, th, td {
  font-size: 11px;
}
table, th, td {
  border-collapse: collapse;
  border: 1px solid;
}
</style>
<!-- <h1>민감정보 수집&middot;이용 동의서</h1> -->
<p>
헬스허브는 서비스 제공을 위하여 아래와 같이 민감정보를 수집&middot이용 및 제공 하고자 합니다.
내용을 자세히 읽으신 후 동의 여부를 결정하여 주십시오.
</p>
<h2>개인 정보 수집&middot;이용 동의(필수)</h2>
<table>
  <thead>
    <tr>
      <th width="40%">항목</th>
      <th width="42%">수집목적</th>
      <th width="18%">보유기간</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>건강검진 정보(키/몸무게/시력/혈압 등)<br>병원/약국 방문 및 투약 정보<br>의료영상 정보</td>
      <td>회원 가입 및 부정사용 방지<br>맞춤형 의학정보 수집<br>개인 의료영상 보관</td>
      <td>5년</td>
    </tr>
  </tbody>
</table>
<p>위의 개인정보 수집&middot;이용에 대한 동의를 거부할 권리가 있습니다. 그러나 동의를 거부할 경우 원활한 서비스 제공에 일부 제한을 받을 수 있습니다.</p>
<p>위와 같이 개인정보를 수집&middot;이용하는데 동의하십니까?</p>
  `,
  [Agreement.personalInformationV2]: `
<meta name="viewport" content="width=device-width user-scalable=0 initial-scale=1.0 mximum-scale=1.0 minimum-scale=1.0">
  <style>
ul, ol {
  padding-left: 2em;
}
ol ol ol {
  padding-left: 1em;
}
h1 {
  font-size: 20px;
}
h2 {
  font-size: 14px;
}
th, td, p, li {
  font-size: 12px;
}
table, th, td {
  border-collapse: collapse;
  border: 1px solid;
  vertical-align: baseline;
}
td {
  padding: 4px;
  box-sizing: border-box;
}
  </style>
<!-- <h1 style="text-align: center;">개인정보처리방침</h1> -->
<p>헬스허브(이하 &quot;회사&quot;라 합니다)는 개인정보보호법 등, 관계 법률에 따라서 이용자의 개인정보 보호 및 권익을 보호하고, 개인정보와 관련한 이용자의 고충을 원활하게 처리할 수 있도록 다음과 같은 처리방침을 두고 있음을 알려드립니다.</p>
<h2>제1조 개인정보의 처리목적, 수집 항목, 보유 및 이용기간</h2>
<p>회사는 다음 각 호의 목적을 위해 필요·최소한의 개인정보를 처리합니다. 개인정보는 다음의 목적 외의 용도로는 사용되지 않으며, 이용 목적이 변경되는 경우에는 별도의 동의를 받는 등, 필요한 조치를 이행할 예정입니다.</p>
<p>
  <table style="border-collapse: collapse; width: 660px;" border="1">
    <tbody>
      <tr>
        <th width="135">항목</th>
        <th width="140">수집 목적</th>
        <th width="110">수집 항목</th>
        <th width="275">보유 및 이용기간</th>
      </tr>
      <tr>
        <td width="135">[HScan]회원 가입 및 관리</td>
        <td width="140">
          회원가입, 가입회원 서비스 제공, 개인식별, 비인가 사용방지, 서비스 부정이용 방지 등
        </td>
        <td width="110">(필수) 아이디, 비밀번호, 휴대전화번호</td>
        <td width="275">
          개인정보 보존: 5년<br><br>
          ※ 회원이 탈회하거나 회원을 제명하는 경우 권리남용방지, 악용방지, 각종 분쟁대비 및 법규상 의무이행을 위하여 이용계약 해지일로부터 5년간 보유함.<br><br>
          ※ 단, 관계 법령 위반에 따른 수사, 조사 등이 진행 중인 경우에는 해당 수사, 조사 종료시까지<br><br>
        </td>
      </tr>
      <tr>
        <td width="135">[HScan]본인인증</td>
        <td width="140">서비스 이용 절차에 따른 본인확인</td>
        <td width="110">(필수) 휴대전화번호, 이름, 성별, 생년월일</td>
        <td width="275">
          개인정보 보존: 5년<br><br>
          ※ 회원이 탈회하거나 회원을 제명하는 경우 권리남용방지, 악용방지, 각종 분쟁대비 및 법규상 의무이행을 위하여 이용계약 해지일로부터 5년간 보유함.<br><br>
          ※ 단, 관계 법령 위반에 따른 수사, 조사 등이 진행 중인 경우에는 해당 수사, 조사 종료시까지<br><br>
        </td>
      </tr>
      <tr>
        <td width="135">[HScan]서비스 제공</td>
        <td width="140">
          의료영상 발급을 위한 조회 서비스 제공, 의료영상 발급 서비스 제공, 의료영상 전달 서비스 제공, 의료영상 업로드 및 보관 서비스 제공, 의료영상 파일 뷰어 제공, 처리결과 통지, 제품 또는 서비스의 홍보 등의 마케팅 활동, 뉴스레터 등의 기타 맞춤 서비스 제공
        </td>
        <td width="110">
          (필수) 이용자가 의료기관으로부터 발급받거나 직접 게시한 의료영상 정보<br><br>
          (선택) 서비스 이용료 결제정보, 주소, 주민등록번호(저장하지 않음)
        </td>
        <td width="275">
          결제 및 서비스 등의 공급에 관한 기록: 5년<br><br>
          계약 또는 청약철회 등에 관한 기록: 5년
        </td>
      </tr>
      <tr>
        <td width="135">[HScan]회사 서비스 향상 및 정책 평가, 교육&middot;연구 및 통계</td>
        <td width="140">
          서비스 이용에 대한 통계 및 분석, 신규 서비스 및 맞춤형 서비스 개발, 회사 내 연구활동 및 교육활동 등.
        </td>
        <td width="110">
          (필수) 서비스 이용기록, 접속 로그, 쿠키, 접속 IP,  세션 정보<br><br>
          (선택) 설문조사 결과
        </td>
        <td width="275">
          로그인 기록: 3개월<br><br>
          설문조사 등의 목적을 위하여 수집한 경우: 당해 설문조사 등이 종료한 때.      
        </td>
      </tr>
      <tr>
        <td width="135">[HScan]민원처리 및 안정성 정보 관리</td>
        <td width="140">
          제품 관련 문의에 대한 응답, 민원인의 신원 확인, 민원사항 확인 사실조사를 위한 연락 및 통지, 처리결과 통보, 제품의 안정성 정보와 품질불만의 보고, 평가 및 관리 등.
        </td>
        <td width="110">(필수) 휴대전화번호</td>
        <td width="275">민원 관련 정보, 안정성 정보 및 품질불만, 분쟁처리에 관한 기록: 3년</td>
      </tr>
      <tr>
        <td width="135">[HScan]가명정보의 처리</td>
        <td width="140">
          상업적 목적을 포함한 통계작성, 과학적 연구, 공익적 기록보존 목적 등을 위한 가명정보 처리.
        </td>
        <td width="110">(필수) 서비스 이용기록</td>
        <td width="275">서비스 공급에 관한 기록: 5년</td>
      </tr>
    </tbody>
  </table>
<p>
<h2>제2조 개인정보의 제3자 제공</h2>
<p>회사는 원칙적으로 정보주체의 개인정보를 제1조(개인정보의 처리목적)에서 명시한 범위 내에서 처리하며, 정보주체의 사전 동의 없이는 제3자에게 제공하지 않습니다. 단, 다음의 경우에는 개인정보를 목적 외의 용도로 이용하거나 제3자에게 제공할 수 있습니다.</p>
<ol>
  <li>정보주체가 사전에 제3자 제공 및 공개에 동의한 경우.</li>
  <li>법률에 특별한 규정이 있는 경우.</li>
  <li>정보주체 또는 그 법정대리인이 의사표시를 할 수 없는 상태에 있거나 주소불명 등으로 사전 동의를 받을 수 없는 경우로서 명백히 당사자 또는 제3자의 급박한 생명 신체 재산의 이익을 위하여 필요하다고 인정되는 경우.</li>
  <li>통계작성, 과학적 연구, 공익적 기록보존 목적 등을 위해 가명처리하여 제공하는 경우.</li>
</ol>
<h2>제3조 개인정보처리의 위탁에 관한 사항</h2>
<ol>
  <li>
    회사는 원활한 개인정보 업무처리를 위해서 아래와 같이 개인정보 처리업무를 외부기관에 위탁하고 있습니다.
    <p>
    <table style="border-collapse: collapse; width: 400px;" border="1">
      <tbody>
        <tr style="text-align: center;">
          <th width="35" style="text-align: center;">No.</th>
          <th width="130">수탁업체명</th>
          <th width="235">위탁업무내용</th>
        </tr>
        <tr>
          <td width="35" style="text-align: center;">1</td>
          <td width="130" style="text-align: center;">㈜다날</td>
          <td width="235">휴대전화번호를 통한 본인인증<br><br></td>
        </tr>
        <tr>
          <td width="35" style="text-align: center;">2</td>
          <td width="130" style="text-align: center;">㈜코리아포트원</td>
          <td width="235">결제 처리<br><br></td>
        </tr>
        <tr>
          <td width="35" style="text-align: center;">3</td>
          <td width="130" style="text-align: center;">비즈톡㈜</td>
          <td width="235">카카오 알림톡 및 문자 발송<br><br></td>
        </tr>
        <tr>
          <td width="35" style="text-align: center;">4</td>
          <td width="130" style="text-align: center;">주식회사 채널코퍼레이션</td>
          <td width="235">고객 상담 업무 일부<br><br></td>
        </tr>
      </tbody>
    </table>
    </p>
  </li>
  <li>회사는 위탁계약 체결 시 개인정보보호법 제26조에 따라 위탁업무 수행목적 외 개인정보 처리금지, 기술적/관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다. 또한, 위탁업무의 내용이나 수탁자가 변경될 경우에는 본 개인정보처리방침을 통하여 공개하고 있습니다.</li>
</ol>
<h2>제4조 개인정보의 안전성 확보조치에 관한 사항</h2>
<ol>
  <li>개인정보 취급 직원의 최소화 및 교육
    <br>개인정보취급자의 지정을 최소화하고 정기적인 교육을 시행하고 있습니다.
  </li>
  <li>정기적인 자체 감사 실시
    <br>개인정보 취급 관련 안정성 확보를 위해 연 1회 이상 정기적으로 자체 감사를 실시하고 있습니다.
  </li>
  <li>내부관리계획의 수립 및 시행
    <br>개인정보의 안전한 처리를 위하여 내부관리계획을 수립하고 시행하고 있습니다.
  </li>
  <li>개인정보의 암호화
    <br>이용자의 개인정보 중 비밀번호는 암호화 되어 저장 및 관리되고 있어 본인만이 알 수 있으며 중요한 데이터는 파일 및 전송 데이터를 암호화 하는 등의 별도 보안기능을 사용하고 있습니다.
  </li>
  <li>해킹 등에 대비한 기술적 대책
    <br>해킹이나 컴퓨터 바이러스 등에 의한 개인정보 유출 및 훼손을 막기 위하여 보안프로그램을 설치하고 주기적인 갱신, 점검을 하며 외부로부터 접근이 통제된 구역에 시스템을 설치하고 기술적/물리적으로 감시 및 차단하고 있습니다.
  </li>
  <li>개인정보에 대한 접근 제한
    <br>개인정보를 처리하는 데이터베이스시스템에 대한 접근권한의 부여, 변경, 말소를 통하여 개인정보에 대한 접근통제를 위하여 필요한 조치를 하고 있으며 침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있습니다.
  </li>
  <li>접속기록의 보관 및 위변조 방지
    <br>개인정보처리시스템에 접속한 기록을 최소 6개월 이상 보관, 관리하고 있으며, 접속 기록이 위변조 및 도난, 분실되지 않도록 보안기능을 사용하고 있습니다.
  </li>
  <li>비인가자에 대한 출입 통제
    <br>개인정보를 보관하고 있는 개인정보시스템의 물리적 보관 장소를 별도로 두고 이에 대해 출입통제 절차를 수립, 운영하고 있습니다.
  </li>
</ol>
<h2>제5조 개인정보 수집&middot;이용에 대한 거부 권리 및 거부 시 불이익</h2>
<ol>
  <li>정보주체는 개인정보 수집, 이용에 대한 동의를 거부할 권리가 있습니다. 단, 동의를 거부할 경우 서비스 이용에 제한이 있을 수 있습니다.</li>
  <li>
    개인정보 자동 수집 장치의 설치&middot;운영 및 그 거부에 관한 사항<br />
    회사는 정보주체의 사용자 인증 또는 맞춤서비스 제공을 위하여&lsquo;쿠키&rsquo;를 이용하고 있습니다. 쿠키는 이용자 사이트에 대한 기본 설정정보를 보관하기 위해 해당 웹사이트가 이용자의 컴퓨터 브라우저에 전송하는 소량의 정보입니다. 정보주체는 정보주체의 웹 브라우저에서 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부할 수 있는 선택권이 있습니다. 단, 쿠키 저장을 거부할 경우에는 서비스 이용에 제한이 있을 수 있습니다.<br>
    [참고] 이용자가 사용하는 각각의 브라우저는 해당 브라우저의 쿠키 설정방법에 따릅니다.
  </li>
</ol>
<h2>제6조 개인정보의 파기</h2>
<ol>
  <li>회사는 개인정보의 보유기간이 경과된 경우 또는 개인정보의 처리 목적 달성, 해당 서비스의 폐지, 사업의 종료 등, 그 개인정보가 불필요하게 되었을 때에는 지체 없이 해당 개인정보를 파기합니다. 단, 상법 등 관련 법규 및 내부방침에 따라 보존하여야 하는 경우에는 파기하지 아니 합니다.</li>
  <li>개인정보가 기록된 출력물 서면 등은 파쇄 또는 소각의 방법으로 파기하고, 전자적 파일 형태의 개인정보는 복원이 불가능한 방법으로 영구 삭제 파기합니다.</li>
</ol>
<h2>제7조 정보주체와 법정대리인의 권리&middot;의무 및 그 행사방법</h2>
<ol>
  <li>개인정보의 열람
    <br>정보주체는 회사를 방문하여 개인정보의 열람을 요구할 수 있으며, 신속하게 이에 대하여 응대합니다.
  </li>
  <li>개인정보의 정정ㆍ삭제
    <br>회사는 정보주체가 개인정보에 대한 정정ㆍ삭제를 요구하는 경우, 개인정보에 오류가 있다고 판명되는 등, 개인정보를 정정ㆍ삭제를 할 필요가 있다고 인정되는 경우에는 지체 없이 정정ㆍ삭제를 합니다. 처리의 정확성을 위하여 회사는 정보주체에게 정정ㆍ삭제 내용의 사실 확인에 필요한 증빙자료를 요청할 수 있습니다.
  </li>
  <li>행사방법
    <ul>
      <li>회사는 정보주체가 개인정보에 대한 열람 정정 및 삭제를 요구하는 경우에는 정보주체의 요구에 성실하게 응대하고 지체 없이 처리합니다. 정보주체의 개인정보를 엄격히 보호하기 위하여 정보주체의 방문 이외의 전화ㆍ우편ㆍFAX 등, 기타 신청방법에 의한 정보주체의 개인정보의 열람 정정 및 삭제 절차는 제공하지 않습니다.</li>
      <li>정보주체는 언제든지 등록되어 있는 자신의 개인정보를 조회하거나 수정할 수 있으며, 회사의 개인정보처리에 동의하지 않는 경우 가입해지(회원탈퇴)를 요청하실 수 있습니다. 그러나 가입해지 시 회사의 서비스 일부 혹은 전부 이용이 어려울 수 있습니다. 정보주체의 개인정보 조회 및 수정은 &quot;마이페이지 - 개인정보 수정&quot;에서 직접 열람 및 정정하실 수 있습니다. 회원탈퇴는 &quot;마이페이지 - 이용약관&quot;에서 직접 수행하실 수 있습니다.</li>
      <li>정보주체가 개인정보에 대한 열람 정정 및 삭제를 요구하는 경우, 정보주체의 신분을 나타내는 주민등록증, 여권, 운전면허증 등의 신분증명서를 제시 받아 본인 여부를 확인합니다.</li>
      <li>정보주체의 대리인이 방문하여 열람 정정 및 삭제를 요구하는 경우에는 정보주체의 위임장 및 동의서와 대리인의 신분증명서 등을 확인하여 정당한 대리인인지 여부를 확인합니다.</li>
      <li>회사는 법률에 특별한 규정이 있거나 법령상 의무를 준수하기 위하여 부가피한 경우 등, 개인정보의 전부 또는 일부에 대하여 열람 정정 및 삭제를 거절할 정당한 이유가 있는 경우에는 정보주체의 요구를 거절할 수 있으며, 이 경우, 정보주체에게 이를 통지하고 그 사유를 알려 드립니다.</li>
    </ul>
  </li>
</ol>
<h2>제8조 개인정보 보호책임자</h2>
<ol>
  <li>회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.
    <ul>
      <li>개인정보 보호책임자: 변시섭 연구소장(CTO)
      <li>개인정보 보호 담당부서: 연구개발기획팀
      <li>전화: 02-511-3601
      <li>Email: hh-planning@healthhub.kr
    </ul>
  </li>
  <li>회사의 서비스를 이용하시면서 발생한 개인정보 보호 관련 모든 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의하실 수 있습니다.</li>
</ol>
<h2>제9조 권익침해 구제방법</h2>
<p>회사 외의 개인정보 침해로 인한 신고나 상담이 필요하신 경우, 아래 기관에 문의하시기 바랍니다.</p>
<ul style="list-style: '▶';">
  <li>개인정보보호 포털(<a href="http://www.privacy.go.kr">privacy.go.kr</a> / 국번없이 118)</li>
  <li>한국인터넷진흥원 개인정보침해신고센터(privacy.kisa.or.kr / 국번없이 118)</li>
  <li>경찰청 사이버수사국(ecrm.cyber.go.kr / 국번없이 112, 182)</li>
</ul>
<h2>제10조 개인정보 처리방침 변경</h2>
<ol>
  <li>본 개인정보처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경 내용의 추가 삭제 및 수정이 있을 경우에는 변경사항의 시행 7일 전부터 공지사항을 통하여 고지하겠습니다.</li>
  <li>이 개인정보 처리방침은 2023. 11. 03부터 적용됩니다.</li>
  <li>
    이전의 개인정보 처리방침은 아래에서 확인하실 수 있습니다.
    <ul>
      <li>2022. 03. 21 ~ 2023. 11. 02 적용 (<a href="https://www.hscan.kr/terms" target="_blank">클릭</a>)</li>
    </ul>
  </li>
</ol>
  `,
  [Agreement.termsOfServiceV2]: `
<meta name="viewport" content="width=device-width user-scalable=0 initial-scale=1.0 mximum-scale=1.0 minimum-scale=1.0">
<style>
ol {
  padding-left: 1em;
}
ol ol {
  padding-left: 1em;
}
h1 {
  font-size: 20px;
}
h2 {
  font-size: 11px;
}
p, li {
  font-size: 11px;
}
</style>
<!-- <h1>서비스 이용약관</h1> -->
<p>헬스허브(이하 &quot;회사&quot;라 합니다)는 HScan 서비스(이하 &quot;서비스&quot;라 합니다)를 제공함에 있어 HScan 서비스 이용약관(이하 &quot;본 약관&quot;이라 합니다)을 적용합니다. 서비스를 이용함으로써 귀하는 본 약관에 동의하게 되므로 본 약관을 주의 깊게 읽어보시기 바랍니다.</p>
<h2>제1조 (목적)</h2>
<ol>
  <li style="list-style: '① ';">본 약관은 이용자가 &quot;회사&quot;에서 제공하는 &quot;서비스&quot;를 이용함에 있어 이용자와 &quot;회사&quot;의 권리&middot;의무 및 책임사항을 규정함을 목적으로 합니다.</li>
  <li style="list-style: '② ';">이용자가 되고자 하는 자가 &quot;회사&quot;가 정한 소정의 절차를 거쳐서 &quot;동의&quot; 단추를 누르면 본 약관에 동의하는 것으로 간주합니다. 본 약관에 정하는 이외의 이용자와 &quot;회사&quot;의 권리, 의무 및 책임사항에 관해서는 대한민국의 관련 법령과 상관습에 의합니다.</li>
</ol>
<h2>제2조 (정의)</h2>
<p>본 약관에서 사용되는 용어의 정의는 다음과 같습니다.</p>
<ol>
  <li style="list-style: '① ';">이용자(회원) : 인터넷 홈페이지에 로그인하여 본 약관에 따라 회사가 제공하는 서비스를 받는 자를 말합니다.</li>
  <li style="list-style: '② ';">운영자 : 서비스의 전반적인 관리와 원활한 운영을 위하여 회사에서 선정한 사람</li>
  <li style="list-style: '③ ';">연결사이트 : 홈페이지와 하이퍼링크 방식(하이퍼링크의 대상에는 문자, 정지 및 동화상 등이 포함됨) 등으로 연결된 웹 사이트를 말합니다.</li>
  <li style="list-style: '④ ';">개인정보 : 당해 정보에 포함되어 있는 성명 등의 사항에 의하여 특정 개인을 식별할 수 있는 정보(당해 정보만으로는 특정 개인을 인식할 수 없더라도 다른 정보와 용이하게 결합하여 식별할 수 있는 것을 포함한다)를 말합니다.</li>
  <li style="list-style: '⑤ ';">해지 : 이용자가 서비스 개통 후 이용계약을 해약하는 것을 의미합니다.</li>
</ol>
<h2>제3조 (약관의 게시 및 변경)</h2>
<ol>
  <li style="list-style: '① ';">회사는 본 약관의 내용과 상호, 소재지, 전자우편 주소 등을 이용자가 알 수 있도록 홈페이지에 게시합니다.</li>
  <li style="list-style: '② ';">회사는 불가피한 사정이 있는 경우 관계법령을 위배하지 않는 범위에서 본 약관을 개정할 수 있습니다.</li>
  <li style="list-style: '③ ';">회사는 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행약관과 함께 서비스화면에 그 적용일자 7일 이전부터 적용일자 전일까지 공지합니다.</li>
  <li style="list-style: '④ ';">이 약관에서 정하지 아니한 사항과 이 약관의 해석에 관하여는 관계법령 또는 상관례에 따릅니다.</li>
</ol>
<h2>제4조 (서비스의 내용 및 변경)</h2>
<ol>
  <li style="list-style: '① ';">회사는 다음의 서비스를 제공합니다.
    <ol>
      <li>의료 영상 발급</li>
      <li>의료 영상 전달(공유)</li>
      <li>의료 영상 보관</li>
      <li>의료 영상 열람</li>
      <li>의료 영상을 활용한 부가서비스</li>
      <li>기타 회사가 정하거나 다른 기관과의 협의를 통해 제공하는 일체의 서비스</li>
    </ol>
  </li>
  <li style="list-style: '② ';">회사는 불가피한 사정이 있는 경우 제공하는 서비스의 내용을 변경할 수 있으며, 이 경우 변경된 서비스의 내용 및 제공 일자를 명시하여 그 제공 일자 이전 7일부터 공지합니다.</li>
  <li style="list-style: '③ ';">회사는 서비스 내용의 변경으로 인하여 이용자가 입은 손해에 대하여 배상하지 아니합니다. 단, 회사의 고의 또는 중과실이 있는 경우에는 그러하지 아니합니다.</li>
</ol>
<h2>제5조 (서비스의 중단)</h2>
<ol>
  <li style="list-style: '① ';">회사는 시스템 등 장치의 보수점검&middot;교체 및 고장, 통신의 두절, 기타 불가항력적 사유가 발생한 경우에는 서비스의 제공을 일시적으로 중단할 수 있습니다.</li>
  <li style="list-style: '② ';">회사는 제1항의 사유로 서비스 제공이 일시적으로 중단됨으로 인하여 이용자 또는 제3자가 입은 손해에 대하여는 배상하지 아니합니다. 단, 회사의 고의 또는 중과실이 있는 경우에는 그러하지 아니합니다.</li>
</ol>
<h2>제6조 (회원가입)</h2>
<ol>
  <li style="list-style: '① ';">이용자는 회사가 정한 양식에 따라 회원정보를 기입한 후 본 약관에 동의한다는 의사표시를 함으로써 회원가입을 신청합니다.</li>
  <li style="list-style: '② ';">회사는 전항과 같이 회원으로 가입할 것을 신청한 이용자 중 이하 각호에 해당하지 않는 한 회원으로 등록합니다.
    <ol>
      <li>가입신청자가 본 약관 제7조 제2항에 의거하여 이전에 회원 자격을 상실한 적이 있는 경우</li>
      <li>등록내용에 허위, 기재누락, 오기가 있는 경우</li>
      <li>기타 회원으로 등록하는 것이 회사의 기술상 또는 업무 수행상 현저히 지장이 있다고 판단하는 경우</li>
      <li>입력한 비밀번호가 8자 이상이 아닌 경우</li>
    </ol>
  </li>
  <li style="list-style: '③ ';">회원가입계약의 성립시기는 회사가 승낙한 시점으로 합니다.</li>
  <li style="list-style: '④ ';">회원은 등록사항에 변경이 있는 경우, 즉시 회원 계정 정보를 변경하거나 전자우편 또는 기타 방법으로 회사에 그 변경사항을 알려야 합니다.</li>
</ol>
<h2>제7조 (회원 탈퇴 및 자격의 상실등)</h2>
<ol>
  <li style="list-style: '① ';">회원은 회사에 언제든지 탈퇴를 요청할 수 있으며 회사는 즉시 회원탈퇴를 처리합니다. 회원탈퇴는 홈페이지에서 로그인 후 &quot;마이페이지 - 이용약관&quot; 하단에서 가능하시며 탈퇴 즉시 귀하의 개인정보를 파기하는 등 필요한 조치를 하겠습니다.</li>
  <li style="list-style: '② ';">회원이 다음 각호의 사유에 해당하는 경우, 회사는 회원자격을 상실시킬 수 있습니다.
    <ol>
      <li>등록 신청 시에 허위 내용을 등록한 경우</li>
      <li>다른 사람의 서비스 이용을 방해하거나 그 정보를 도용하는 등 질서를 위협하는 경우</li>
      <li>서비스 내에서 검증되지 않은 허위정보 및 기타 허락되지 않은 물품의 판매 행위를 하는 경우</li>
      <li>서비스 내에서 허락되지 않은 진료행위 또는 진료행위를 위한 선전의 장소로 이용하는 경우</li>
      <li>서비스 내에 제공되는 정보를 변경하는 등 홈페이지 운영을 방해한 경우</li>
      <li>서비스를 이용하여 법령과 본 약관이 금지하거나 공서양속에 반하는 행위를 하는 경우</li>
      <li>본 약관을 위반한 경우</li>
      <li>기타 회원으로서의 자격을 지속시키는 것이 부적절하다고 판단되는 경우</li>
    </ol>
  </li>
</ol>
<h2>제8조 (회원에 대한 통지)</h2>
<ol>
  <li style="list-style: '① ';">회사는 회원에 대한 통지를 하는 경우, 회원이 회사에 제공한 전화번호로 할 수 있습니다.</li>
  <li style="list-style: '② ';">회사는 불특정다수 회원에 대한 통지의 경우 홈페이지에 게시함으로써 개별통지에 갈음할 수 있습니다.</li>
</ol>
<h2>제9조 (이용자의 의무)</h2>
<ol>
  <li style="list-style: '① ';">이용자는 다음의 행위를 하여서는 안됩니다.
    <ol>
      <li>신청 또는 변경 시 허위내용의 등록</li>
      <li>회사에 게시된 정보의 변경</li>
      <li>회사가 정한 정보 이외의 정보(컴퓨터프로그램 등)의 송신 또는 게시</li>
      <li>회사 기타 제3자의 저작권 등 지적재산권에 대한 침해</li>
      <li>회사 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위</li>
      <li>외설 또는 폭력적인 메시지·화상·음성 기타 공서양속에 반하는 정보를 회사에 공개 또는 게시하는 행위</li>
      <li>다른 이용자에 대한 건강진료 및 상담을 하거나 알선하는 행위</li>
      <li>제3자의 진료행위를 선전하는 행위</li>
      <li>상품을 판매하거나 판매를 알선하는 행위</li>
      <li>기타 부적절하다고 판단하는 행위</li>
    </ol>
  </li>
  <li style="list-style: '② ';">전항 각호의 정보 또는 기타 회사 사이트 운영상 부적절하다고 판단한 정보가 홈페이지에 게시되거나 사이트와 링크된 곳에 게시된 경우, 회사는 이용자 또는 기타 정보의 게시를 행한 자의 승낙 없이 홈페이지에 게재된 당해 정보를 삭제하거나 링크를 단절할 수 있습니다. 단, 회사는 이러한 정보의 삭제·링크의 절단 등을 할 의무를 지지 않습니다.</li>
</ol>
<h2>제10조 (이용자의 비밀번호에 대한 의무)</h2>
<ol>
  <li style="list-style: '① ';">이용자는 서비스를 이용하는 경우 비밀번호를 사용해야 합니다.</li>
  <li style="list-style: '② ';">비밀번호에 관한 모든 관리의 책임은 이용자에게 있습니다.</li>
  <li style="list-style: '③ ';">이용자는 자신의 비밀번호를 제3자에게 이용하게 해서는 안됩니다.</li>
  <li style="list-style: '④ ';">이용자의 비밀번호의 관리의 부실로 인한 모든 책임은 이용자가 부담합니다.</li>
  <li style="list-style: '⑤ ';">이용자는 비밀번호를 도난당하거나 제3자에게 사용되고 있음을 인지한 경우에는 바로 회사에 통보하고 회사의 안내가 있는 경우에는 그에 따라야 합니다.</li>
</ol>
<h2>제11조 (회사의 의무)</h2>
<ol>
  <li style="list-style: '① ';">회사는 법령과 본 약관이 금지하거나 공서양속에 반하는 행위를 하지 않으며 본 약관이 정하는 바에 따라 지속적이고, 안정적으로 서비스를 제공하는 데 최선을 다합니다.</li>
  <li style="list-style: '② ';">회사는 이용자의 신용정보를 포함한 개인신상정보의 보안에 대하여 기술적 안전 조치를 강구하고 관리에 만전을 기함으로써 이용자의 정보보안에 최선을 다합니다.</li>
  <li style="list-style: '③ ';">회사는 공정하고 건전한 운영과 지속적인 연구·개발을 통하여 양질의 서비스를 제공함으로써 고객만족을 극대화하여 인터넷 비즈니스 발전에 기여하도록 합니다.</li>
  <li style="list-style: '④ ';">회사는 이용자가 원하지 않는 영리 목적의 광고성 문자메시지를 발송하지 않습니다.</li>
</ol>
<h2>제12조 (건강 관련 정보 제공 서비스)</h2>
<ol>
  <li style="list-style: '① ';">회사에서 제공하는 건강 관련정보는 개략적이며 일반적인 것으로서 특정인의 의견에 지나지 않으며 어떠한 경우에도 전문적인 의학적 진단, 진료, 치료를 대신할 수 없습니다.</li>
  <li style="list-style: '② ';">회사는 건강 관련정보제공서비스에서 언급된 어떠한 특정한 검사나 제품 또는 치료법을 보증하지 않습니다.</li>
  <li style="list-style: '③ ';">회사는 제공하는 건강 관련 정보는 전적으로 이용자의 판단에 따라 이용되는 것으로서, 회사는 건강 관련정보의 제공과 관련하여 어떠한 책임도 지지 않습니다.</li>
</ol>
<h2>제13조 (회사와 연결 사이트 간의 관계)</h2>
<p>회사는 연결 사이트가 독자적으로 제공하는 재화, 용역, 서비스에 의하여 이용자와 행하는 거래에 대해서 어떠한 보증책임을 지지 않습니다.</p>
<h2>제14조 (개인정보의 수집)</h2>
<ol>
  <li style="list-style: '① ';">회사는 이용자의 정보수집시 필요한 최소한의 정보를 수집합니다. 다음 사항을 필수 사항으로 하며 그 외 사항은 선택사항으로 합니다.
    <ol>
      <li>아이디</li>
      <li>휴대전화번호</li>
      <li>비밀번호</li>
      <li>이름</li>
      <li>성별</li>
      <li>생년월일</li>
    </ol>
  </li>
  <li style="list-style: '② ';">이용자의 개인정보를 수집하는 때에는 이하 각호의 경우를 제외하고는 당해 이용자의 동의를 받습니다.
    <ol>
      <li>법률에 특별한 규정이 있는 경우</li>
      <li>서비스이용계약의 이행을 위해서 필요한 경우</li>
      <li>서비스의 제공에 따른 요금정산을 위하여 필요한 경우</li>
    </ol>
  </li>
  <li style="list-style: '③ ';">회사는 개인정보의 보호를 위하여 관리자를 한정하여 그 수를 최소화하며 개인정보의 분실, 도난, 유출, 변조되지 아니하도록 안정성 확보에 필요한 기술적 조치 등을 강구합니다.</li>
  <li style="list-style: '④ ';">회사는 개인정보의 수집목적을 달성한 때에는 당해 개인정보를 지체없이 파기합니다.</li>
</ol>
<h2>제15조(개인정보의 관리책임자)</h2>
<ol>
  <li style="list-style: '① ';">관리책임자: 헬스허브 기업부설연구소 변시섭 연구소장(CTO)</li>
  <li style="list-style: '② ';">전화번호: 02-511-3601</li>
  <li style="list-style: '③ ';">메일: hh-planning@healthhub.kr</li>
</ol>
<h2>제16조(개인정보의 수집목적 및 이용목적)</h2>
<ol>
  <li style="list-style: '① ';">이용자에게 원활한 서비스 제공을 위한 온라인 및 오프라인에서의 공지기능</li>
  <li style="list-style: '② ';">사용자 인증 절차 및 서비스 제공</li>
  <li style="list-style: '③ ';">서비스 원활한 운영 및 통계분석자료로 활용</li>
</ol>
<h2>제17조(개인정보의 보유기간 및 이용기간)</h2>
<p>회사는 개인정보처리방침을 마련하여 보유기간 및 이용기간을 규정합니다.</p>
<h2>제18조(개인정보의 이용 및 제공의 제한)</h2>
<ol>
  <li style="list-style: '① ';">제공된 개인정보는 당해 이용자의 동의 없이 목적 외 이용이나 제3자에게 제공할 수 없으며, 이에 따른 이용자의 피해에 대한 모든 책임은 회사가 집니다. 단, 다음의 경우에는 예외로 합니다.
    <ol>
      <li>법률에 특별한 규정이 있는 경우</li>
      <li>서비스의 제공에 따른 요금정산 및 배송 등을 위하여 필요한 경우</li>
      <li>통계작성&middot;학술연구 또는 시장조사를 위하여 필요한 경우로서 특정 개인을 식별할 수 없는 형태로 제공하는 경우</li>
    </ol>
  </li>
  <li style="list-style: '② ';">정보통신서비스제공자로부터 이용자의 개인정보를 제공받은 자는 당해 이용자의 동의가 있거나 다른 법률에 특별한 규정이 있는 경우를 제외하고는 개인정보를 제공받은 목적 외의 용도로 이를 이용하거나 제3자에게 제공하여서는 안됩니다.</li>
</ol>
<h2>제19조(이용자의 권리)</h2>
<ol>
  <li style="list-style: '① ';">이용자는 언제든지 제14조 제2항, 제18조 제1항 및 제2항의 규정에 의한 동의를 철회할 수 있습니다. 단, 철회의 의사표시는 회사 또는 회사로부터 정보를 제공받은 자에게 전자우편이 도달된 때로부터 유효합니다.</li>
  <li style="list-style: '② ';">이용자는 회사에게 자신의 개인정보에 대한 열람을 요구할 수 있으며, 자신의 개인정보에 오류가 있는 경우에는 그 정정을 요구할 수 있습니다.</li>
  <li style="list-style: '③ ';">제1항 및 제2항에 의한 철회, 열람, 정정의 요구는 회사에 전자우편을 보내는 방식으로 하여야 하며, 회사는 전자우편이 도달된 후 지체없이 필요한 조치를 취할 의무를 집니다. 이용자가 오류의 정정을 요구한 경우에는 회사가 그 오류를 정정할 때까지 당해 개인정보를 이용하지 않습니다.</li>
</ol>
<h2>제20조 (저작권의 귀속 및 이용제한)</h2>
<ol>
  <li style="list-style: '① ';">회사가 작성한 저작물에 대한 저작권 기타 지적재산권은 회사에 귀속합니다.</li>
  <li style="list-style: '② ';">이용자는 홈페이지를 이용함으로써 얻은 정보를 회사의 사전 승낙 없이 복제, 송신, 출판, 배포, 방송 기타 방법에 의하여 영리 목적으로 이용하거나 제3 자에게 이용하게 하여서는 안됩니다.</li>
</ol>
<h2>제21조 (분쟁해결)</h2>
<ol>
  <li style="list-style: '① ';">본 이용약관에 규정된 것을 제외하고 발생하는 서비스 이용에 관한 제반 문제에 관한 분쟁은 최대한 쌍방합의에 의해 해결하도록 합니다.</li>
  <li style="list-style: '② ';">이용자가 홈페이지 이용과 관련하여 불만이 있거나 의견을 제시하고자 하는 경우 전자우편으로 홈페이지에 대한 불만사항 또는 의견을 제출하면 됩니다.</li>
  <li style="list-style: '③ ';">회사는 이용자로부터 제출되는 불만사항 및 의견이 정당하다고 판단하는 경우 우선적으로 그 사항을 처리합니다. 다만, 신속한 처리가 곤란한 경우에는 이용자에게 그 사유와 처리일정을 즉시 통보해 드립니다.</li>
</ol>
<h2>제22조 (재판권 및 준거법)</h2>
<ol>
  <li style="list-style: '① ';">회사와 이용자 간에 서비스 이용으로 발생한 분쟁에 관한 소송은 민사소송법상의 관할법원으로 합니다.</li>
  <li style="list-style: '② ';">회사와 이용자 간에 제기된 전자거래 소송에는 대한민국법을 적용합니다.</li>
</ol>
<h2>제23조 (이용약관 변경)</h2>
<ol>
  <li style="list-style: '① ';">본 이용약관은 시행일로부터 적용되며, 법령 및 방침에 따른 변경 내용의 추가 삭제 및 수정이 있을 경우에는 변경사항의 시행 7일 전부터 공지사항을 통하여 고지하겠습니다.</li>
  <li style="list-style: '② ';">본 이용약관은 2023. 11. 03부터 적용됩니다. 이전의 이용약관은 아래에서 확인하실 수 있습니다.
    <ul>
      <li>2022. 03. 21 ~ 2023. 11. 02 적용 (<a href="https://www.hscan.kr/terms" target="_blank">클릭</a>)</li>
    </ul>
  </li>
</ol>
  `,
  [Agreement.termsOfServiceEn]: `
<meta name="viewport" content="width=device-width user-scalable=0 initial-scale=1.0 mximum-scale=1.0 minimum-scale=1.0">
<style>
ol {
  padding-left: 1em;
}
ol ol {
  padding-left: 1em;
}
h1 {
  font-size: 20px;
}
h2 {
  font-size: 11px;
}
p, li {
  font-size: 11px;
}
</style>
<p>Telenasindo (hereinafter referred to as the “Company”) applies the Thetraris Service Terms of Use (hereinafter referred to as “these Terms”) when providing the Thetraris service (hereinafter referred to as the “Service”). By using the Service, you agree to these Terms, so please read these Terms carefully.</p>
<h2>Article 1 (Purpose)</h2>
<ol>
  <li style="list-style: '① ';">The purpose of these Terms and Conditions is to stipulate the rights, obligations and responsibilities of the User and the “Company” when the User uses the “Service” provided by the “Company”.</li>
  <li style="list-style: '② ';">If a person who wishes to become a user clicks the “Agree” button after going through the prescribed procedure set by the “Company,” he or she is considered to have agreed to these Terms and Conditions. With regard to the rights, obligations, and responsibilities of the user and the “Company” other than those set forth in these Terms and Conditions, the relevant laws and customs of the Indonesia shall apply.</li>
</ol>
<h2>Article 2 (Definition)</h2>
<p>The terms used in these Terms and Conditions are defined as follows.</p>
<ol>
  <li style="list-style: '① ';">User (Member): refers to a person who logs into the Internet homepage and receives services provided by the company in accordance with these Terms and Conditions.</li>
  <li style="list-style: '② ';">Operator: A person selected by the company to manage the overall service and ensure smooth operation.</li>
  <li style="list-style: '③ ';">Linked site: refers to a website that is linked to the homepage through a hyperlink (the target of the hyperlink includes text, still images, and moving images).</li>
  <li style="list-style: '④ ';">Personal information: refers to information that can identify a specific individual through matters such as name included in the information (even if the information alone cannot identify a specific individual, it includes information that can be easily combined with other information to identify the individual).</li>
  <li style="list-style: '⑤ ';">Termination: This refers to the user canceling the service agreement after the service has been initiated.</li>
</ol>
<h2>Article 3 (Posting and changing terms and conditions)</h2>
<ol>
  <li style="list-style: '① ';">The company posts the contents of these terms and conditions, its name, location, email address, etc. on its website so that users can view them.</li>
  <li style="list-style: '② ';">In case of unavoidable circumstances, the company may revise these terms and conditions to the extent that it does not violate relevant laws and regulations.</li>
  <li style="list-style: '③ ';">When the company revises the terms and conditions, it will post the effective date and reason for revision on the service screen along with the current terms and conditions from 7 days prior to the effective date until the day before the effective date.</li>
  <li style="list-style: '④ ';">Matters not specified in these Terms and Conditions and the interpretation of these Terms and Conditions shall be governed by relevant laws and regulations or commercial practices.</li>
</ol>
<h2>Article 4 (Contents and Changes of Services)</h2>
<ol>
  <li style="list-style: '① ';">The company provides the following services.
    <ol>
      <li>Issuance of medical images</li>
      <li>Medical Image Transmission (Sharing)</li>
      <li>Medical Image Archiving</li>
      <li>Medical Image Viewing</li>
      <li>Additional services using medical imaging</li>
      <li>Any other service provided by the company or through consultation with other agencies</li>
    </ol>
  </li>
  <li style="list-style: '② ';">In case of unavoidable circumstances, the company may change the content of the services provided, and in this case, the company will specify the content of the changed services and the date of provision and announce it 7 days prior to the date of provision.</li>
  <li style="list-style: '③ ';">The company shall not compensate for any damages suffered by the user due to changes in the service content. However, this shall not apply in cases of intent or gross negligence on the part of the company.</li>
</ol>
<h2>Article 5 (Suspension of Service)</h2>
<ol>
  <li style="list-style: '① ';">The Company may temporarily suspend the provision of services in the event of maintenance, inspection, replacement, or breakdown of devices such as systems, communication disruption, or other force majeure.</li>
  <li style="list-style: '② ';">The Company shall not compensate for any damages suffered by users or third parties due to temporary suspension of service provision for the reasons set forth in Paragraph 1. However, this shall not apply in cases of intent or gross negligence on the part of the Company.</li>
</ol>
<h2>Article 6 (Membership Registration)</h2>
<ol>
  <li style="list-style: '① ';">Users apply for membership by filling out membership information in the form prescribed by the company and indicating their agreement to these terms and conditions.</li>
  <li style="list-style: '② ';">The company will register as a member any user who has applied for membership as per the preceding paragraph, unless he or she falls under any of the following items.
    <ol>
      <li>If the applicant has previously lost membership qualifications pursuant to Article 7, Paragraph 2 of these Terms and Conditions</li>
      <li>If there is any false information, omission, or error in the registration information</li>
      <li>If it is determined that registering as a member of the other significantly hinders the company's technology or business operations</li>
      <li>The password you entered is not more than 8 characters</li>
    </ol>
  </li>
  <li style="list-style: '③ ';">The time when the membership contract is established is when the company approves.</li>
  <li style="list-style: '④ ';">If there is a change in the registration information, the member must immediately change the member account information or notify the company of the change via e-mail or other means.</li>
</ol>
<h2>Article 7 (Withdrawal of membership and loss of qualification, etc.)</h2>
<ol>
  <li style="list-style: '① ';">Members can leave the membership at the bottom of "My Page - Terms and Conditions" after logging in from the website, and we will take necessary measures, such as destroying your personal information immediately after leaving.</li>
  <li style="list-style: '② ';">If a member falls under any of the following reasons, the company may revoke the member’s membership.
    <ol>
      <li>If false information is registered when applying for registration</li>
      <li>In case of threatening order by interfering with other people's use of the service or stealing their information</li>
      <li>In case of selling unverified false information or other unauthorized items within the service</li>
      <li>Where it is used as a place of propaganda for unauthorized medical treatment or medical treatment within the service</li>
      <li>Where the operation of the website is hindered, such as changing the information provided within the service</li>
      <li>Where the Act and the Terms and Conditions prohibit or act contrary to public order and morals by using the service</li>
      <li>If you violate these Terms and Conditions</li>
      <li>Where it is deemed inappropriate to continue its qualifications as a member</li>
    </ol>
  </li>
</ol>
<h2>Article 8 (Notice to members)</h2>
<ol>
  <li style="list-style: '① ';">When the company notifies a member, it may do so by using the phone number provided by the member to the company.</li>
  <li style="list-style: '② ';">In case of notification to an unspecified number of members, the company may substitute individual notification by posting on the website.</li>
</ol>
<h2>Article 9 (User Obligations)</h2>
<ol>
  <li style="list-style: '① ';">Users must not perform the following actions:
    <ol>
      <li>Registration of false information when applying or changing</li>
      <li>Changes to information posted on the company</li>
      <li>Transmission or publication of information (computer program, etc.) other than the information set by the company</li>
      <li>Infringement of intellectual property rights, including copyrights, of the company or other third parties</li>
      <li>Any act that damages the reputation of the company or interferes with the business of a third party</li>
      <li>Disclosure or posting of obscene or violent messages, videos, voices, or other information contrary to public order and morals to the company</li>
      <li>Acts of providing or arranging health care and consultation for other users</li>
      <li>Acts of promoting the medical practice of a third party</li>
      <li>the act of selling or mediating the sale of goods</li>
      <li>Any other acts deemed inappropriate</li>
    </ol>
  </li>
  <li style="list-style: '② ';">If any of the information in each of the preceding paragraphs or any other information deemed inappropriate for the operation of the Company’s website is posted on the website or posted in a location linked to the website, the Company may delete the information posted on the website or disconnect the link without the consent of the user or other person who posted the information. However, the Company is not obligated to delete such information or disconnect the link.</li>
</ol>
<h2>Article 10 (User’s Obligations Regarding Password)</h2>
<ol>
  <li style="list-style: '① ';">Users must use a password when using the service.</li>
  <li style="list-style: '② ';">All responsibility for password management lies with the user.</li>
  <li style="list-style: '③ ';">Users must not allow third parties to use their passwords.</li>
  <li style="list-style: '④ ';">The user shall be responsible for all liabilities resulting from poor management of the user’s password.</li>
  <li style="list-style: '⑤ ';">If a user becomes aware that his or her password has been stolen or is being used by a third party, he or she must immediately notify the company and follow any instructions provided by the company.</li>
</ol>
<h2>Article 11 (Company Obligations)</h2>
<ol>
  <li style="list-style: '① ';">The company will not engage in any acts prohibited by laws and regulations or these Terms and Conditions or that are against public order and morals, and will do its best to provide services continuously and stably in accordance with these Terms and Conditions.</li>
  <li style="list-style: '② ';">The company does its best to protect users’ information security by implementing technical safety measures and making every effort to manage personal information, including users’ credit information.</li>
  <li style="list-style: '③ ';">The company will maximize customer satisfaction by providing quality services through fair and sound operation and continuous research and development, thereby contributing to the development of Internet business.</li>
  <li style="list-style: '④ ';">The company does not send commercial advertising text messages that users do not want.</li>
</ol>
<h2>Article 12 (Health-related information provision services)</h2>
<ol>
  <li style="list-style: '① ';">The health-related information provided by the company is general and outlined, and is nothing more than the opinions of specific individuals. It cannot, under any circumstances, replace professional medical diagnosis, treatment, or care.</li>
  <li style="list-style: '② ';">The company does not guarantee any specific tests, products, or treatments mentioned in the health-related information provision service.</li>
  <li style="list-style: '③ ';">The health-related information provided by the company is used entirely at the user’s discretion, and the company bears no responsibility whatsoever regarding the provision of health-related information.</li>
</ol>
<h2>Article 13 (Relationship between the Company and linked sites)</h2>
<p>The Company shall not be responsible for any guarantees regarding transactions with users by means of goods, services, or services provided independently by the consolidated site.</p>
<h2>Article 14 (Collection of personal information)</h2>
<ol>
  <li style="list-style: '① ';">The company collects the minimum amount of information necessary when collecting user information. The following items are mandatory, and other items are optional.
    <ol>
      <li>Id</li>
      <li>Mobile phone number</li>
      <li>Password</li>
      <li>Name</li>
      <li>Gender</li>
      <li>Birth date</li>
      <li>E-mail</li>
    </ol>
  </li>
  <li style="list-style: '② ';">When collecting personal information of users, consent from the relevant user is obtained, except in the cases listed below.
    <ol>
      <li>In cases where there are special provisions in the law</li>
      <li>When necessary for the performance of the service use agreement</li>
      <li>When necessary for billing for the provision of services</li>
    </ol>
  </li>
  <li style="list-style: '③ ';">In order to protect personal information, the company limits the number of administrators to a minimum and implements technical measures necessary to ensure stability so that personal information is not lost, stolen, leaked, or altered.</li>
  <li style="list-style: '④ ';">When the company has achieved the purpose of collecting personal information, it destroys the personal information without delay.</li>
</ol>
<h2>Article 15 (Personal Information Management Officer)</h2>
<ol>
  <li style="list-style: '① ';">Manager: Telenasindo Slamet</li>
  <li style="list-style: '② ';">Phone number: +62 822-4971-2380</li>
  <li style="list-style: '③ ';">Email: hh-planning@healthhub.kr</li>
</ol>
<h2>Article 16 (Purpose of collection and use of personal information)</h2>
<ol>
  <li style="list-style: '① ';">Online and offline notification functions to provide smooth service to users</li>
  <li style="list-style: '② ';">User authentication procedures and service provision</li>
  <li style="list-style: '③ ';">Use for smooth operation of services and statistical analysis data</li>
</ol>
<h2>Article 17 (Retention and use period of personal information)</h2>
<p>The company establishes a personal information processing policy and stipulates the retention and use period of personal information.</p>
<h2>Article 18 (Restrictions on the use and provision of personal information)</h2>
<ol>
  <li style="list-style: '① ';">Personal information provided cannot be used for purposes other than those agreed to by the user or provided to third parties without the user’s consent, and the company assumes all responsibility for any damages suffered by the user as a result. However, the following cases are exceptions.
    <ol>
      <li>In cases where there are special provisions in the law</li>
      <li>When necessary for billing and delivery in accordance with the provision of services</li>
      <li>Where it is necessary for statistics preparation, academic research, or market research and is provided in a form in which a specific individual cannot be identified</li>
    </ol>
  </li>
  <li style="list-style: '② ';">A person who has received personal information of a user from an information and communication service provider shall not use the personal information for purposes other than the purpose for which it was provided or provide it to a third party, unless there is consent from the user or special provisions in other laws.</li>
</ol>
<h2>Article 19 (User Rights)</h2>
<ol>
  <li style="list-style: '① ';">Users may withdraw consent pursuant to Article 14, Paragraph 2, and Article 18, Paragraphs 1 and 2 at any time. However, the withdrawal notice is effective from the time the e-mail is delivered to the company or the person who received information from the company.</li>
  <li style="list-style: '② ';">Users may request the company to view their personal information, and if there is an error in their personal information, they may request correction.</li>
  <li style="list-style: '③ ';">Requests for withdrawal, inspection, and correction under Paragraphs 1 and 2 must be made by sending an e-mail to the company, and the company has an obligation to take necessary measures without delay after the e-mail arrives. If a user requests correction of an error, the company will not use the relevant personal information until the error is corrected.</li>
</ol>
<h2>Article 20 (Copyright attribution and restrictions on use)</h2>
<ol>
  <li style="list-style: '① ';">Copyright and other intellectual property rights for works created by the company belong to the company.</li>
  <li style="list-style: '② ';">Users may not use the information obtained through the website for profit-making purposes or allow third parties to use it through reproduction, transmission, publication, distribution, broadcasting or any other means without the company’s prior consent.</li>
</ol>
<h2>Article 21 (Dispute Resolution)</h2>
<ol>
  <li style="list-style: '① ';">Disputes regarding the use of services arising except as provided in this Terms and Conditions shall be resolved by bilateral agreement as much as possible.</li>
  <li style="list-style: '② ';">If a user has any complaints or wishes to provide opinions regarding the use of the website, he or she may submit his or her complaints or opinions regarding the website by e-mail.</li>
  <li style="list-style: '③ ';">If the company determines that complaints and opinions submitted by users are justified, it will give priority to processing such matters. However, if prompt processing is difficult, the company will immediately notify the user of the reason and processing schedule.</li>
</ol>
<h2>Article 22 (Jurisdiction and Governing Law)</h2>
<ol>
  <li style="list-style: '① ';">Any lawsuit regarding disputes arising between the company and users from the use of the service shall be filed in the court with jurisdiction under the Civil Procedure Act.</li>
  <li style="list-style: '② ';">The laws of the Indonesia apply to e-commerce lawsuits filed between the company and users.</li>
</ol>
<h2>Article 23 (Changes to Terms of Use)</h2>
<ol>
  <li style="list-style: '① ';">These Terms of Use shall be applied from the date of enforcement. In the event of additions, deletions, or modifications to the contents due to changes in laws and policies, notice shall be given through a notice 7 days prior to enforcement of the changes.</li>
  <li style="list-style: '② ';">These Terms of Use apply from October 11, 2024. You can check the previous Terms of Use below.
    <ul>
      <li>Applies from 2024. 10. 01 to 2024. 10. 11 (<a href="https://www.myscan.cloud/terms" target="_blank">Click</a>)</li>
    </ul>
  </li>
</ol>`,
  [Agreement.personalInformationEn]: `
<meta name="viewport" content="width=device-width user-scalable=0 initial-scale=1.0 mximum-scale=1.0 minimum-scale=1.0">
<style>
ul, ol {
  padding-left: 2em;
}
ol ol ol {
  padding-left: 1em;
}
h1 {
  font-size: 20px;
}
h2 {
  font-size: 14px;
}
th, td, p, li {
  font-size: 12px;
}
table, th, td {
  border-collapse: collapse;
  border: 1px solid;
  vertical-align: baseline;
}
td {
  padding: 4px;
  box-sizing: border-box;
}
</style>
<!-- <h1 style="text-align: center;">개인정보처리방침</h1> -->
<p>Telenasindo (hereinafter referred to as the &quot;Company&quot;) hereby informs you that it has established the following processing policy in order to protect users’ personal information and rights in accordance with the Personal Information Protection Act and other relevant laws and to smoothly handle users’ complaints regarding personal information.</p>
<h2>Article 1 Purpose of processing personal information, items collected, retention and use period</h2>
<p>The company processes the minimum amount of personal information necessary for the following purposes. Personal information will not be used for purposes other than the following, and if the purpose of use changes, necessary measures such as obtaining separate consent will be implemented.</p>
<p>
  <table style="border-collapse: collapse; width: 660px;" border="1">
    <tbody>
      <tr>
        <th width="135">Item</th>
        <th width="140">Purpose of collection</th>
        <th width="110">Collection items</th>
        <th width="275">Retention and Use Period</th>
      </tr>
      <tr>
        <td width="135">[Thetraris]Membership registration and management</td>
        <td width="140">
          Membership registration, provision of membership services, personal identification, prevention of unauthorized use, prevention of service misuse, etc.
        </td>
        <td width="110">(Required) ID, password, mobile phone number</td>
        <td width="275">
          Personal information retention: 5 years<br><br>
          ※ In the event that a member withdraws or is expelled, the information will be retained for 5 years from the date of termination of the service agreement in order to prevent abuse of rights, prevent misuse, prepare for various disputes, and fulfill legal obligations.<br><br>
          ※ However, in the event that an investigation or inquiry is in progress due to a violation of relevant laws and regulations, the information will be retained until the end of the investigation or inquiry.<br><br>
        </td>
      </tr>
      <tr>
        <td width="135">[Thetraris]Service provision</td>
        <td width="140">Provision of inquiry services for issuing medical images, provision of medical image issuance services, provision of medical image transmission services, provision of medical image upload and storage services, provision of medical image file viewers, notification of processing results, marketing activities such as promotion of products or services, provision of other customized services such as newsletters</td>
        <td width="110">
          (Required) Medical image information issued by the user from a medical institution or posted directly<br><br>
          (Optional) Service usage fee payment information, address, resident registration number (not stored)</td>
        <td width="275">
          Records of payment and provision of services, etc.: 5 years Records of contracts or cancellations of subscriptions, etc.: 5 years
        </td>
      </tr>
      <tr>
        <td width="135">[Thetraris]Improving company services and evaluating policies, education, research and statistics</td>
        <td width="140">
          Statistics and analysis on service usage, development of new and customized services, research and education activities within the company, etc.
        </td>
        <td width="110">
          (Required) Service usage records, access logs, cookies, access IP, session information<br><br>
          (Optional) Survey results
        </td>
        <td width="275">
          Login history: 3 months<br><br>
          In case of collection for purposes such as surveys: When the survey in question is completed.
        </td>
      </tr>
      <tr>
        <td width="135">[Thetraris]Management of civil complaints and stability information</td>
        <td width="140">
          Responding to product-related inquiries, verifying the identity of the complainant, contacting and notifying for fact-finding investigation of the complaint, notifying the results of processing, reporting, evaluating and managing product stability information and quality complaints, etc.
        </td>
        <td width="110">
          (Required) Mobile phone number<br><br>
        </td>
        <td width="275">
          Records of complaints, stability information, quality complaints, and dispute resolution: 3 years      
        </td>
      </tr>
      <tr>
        <td width="135">[Thetraris]Processing of pseudonymized information</td>
        <td width="140">
          Records of complaints, stability information, quality complaints, and dispute resolution: 3 years
        </td>
        <td width="110">(Required) Service usage history</td>
        <td width="275">Records of service provision: 5 years</td>
      </tr>
    </tbody>
  </table>
<p>
<h2>Article 2 Provision of personal information to third parties</h2>
<p>In principle, the company processes the personal information of the data subject within the scope specified in Article 1 (Purpose of Processing Personal Information) and does not provide it to a third party without the prior consent of the data subject. However, in the following cases, personal information may be used for purposes other than the intended purpose or provided to a third party. If the data subject has agreed to provision and disclosure to a third party in advance.
</p>
<ol>
  <li>In cases where there are special provisions in the law</li>
  <li>In cases where the data subject or his/her legal representative is unable to express his/her intention or where prior consent cannot be obtained due to unknown address, etc., and it is clearly deemed necessary for the urgent life, body, or property interests of the data subject or a third party.</li>
  <li>In cases where information is provided under pseudonymization for purposes such as compiling statistics, scientific research, and public record keeping purposes.</li>
</ol>
<h2>Article 3 Matters concerning entrustment of personal information processing</h2>
<ol>
  <li>
    In order to process personal information smoothly, the company entrusts personal information processing tasks to external organizations.
    <p>
    <table style="border-collapse: collapse; width: 400px;" border="1">
      <tbody>
        <tr style="text-align: center;">
          <th width="35" style="text-align: center;">No.</th>
          <th width="130">Name of the consignee</th>
          <th width="235">Consignment work content</th>
        </tr>
        <tr>
          <td width="35" style="text-align: center;">1</td>
          <td width="130" style="text-align: center;">Twilio Co., Ltd.</td>
          <td width="235">Sending WhatsApp notifications and text messages<br><br></td>
        </tr>
        <tr>
          <td width="35" style="text-align: center;">2</td>
          <td width="130" style="text-align: center;">Channel Corporation Co., Ltd.</td>
          <td width="235">Part of customer consultation work<br><br></td>
        </tr>
      </tbody>
    </table>
    </p>
  </li>
  <li>In accordance with Article 26 of the Personal Information Protection Act, the company stipulates matters concerning responsibilities such as prohibition of processing personal information other than the purpose of performing consignment work, technical and administrative protection measures, re-consignment restrictions, management supervision of trustees, and compensation for damages in documents such as contracts, and supervises whether the trustee handles personal information safely. In addition, if the contents of the consignment work or the trustee changes, we disclose them through this personal information processing policy.</li>
</ol>
<h2>Article 4 Matters concerning measures to ensure the safety of personal information</h2>
<ol>
  <li>Minimizing and training personal information handling staff
    <br>We are minimizing the designation of personal information handlers and conducting regular training.
  </li>
  <li>To ensure the stability of personal information handling
    <br>we conduct regular self-audits at least once a year.
  </li>
  <li>Establishment and implementation of an internal management plan
    <br>We are establishing and implementing an internal management plan to ensure the safe processing of personal information.
  </li>
  <li>Encryption of Personal Information
    <br>The password of the user's personal information is encrypted, stored, and managed, so only you can know it, and important data uses separate security functions such as encrypting files and transmission data.
  </li>
  <li>Technical measures against hacking, etc.
    <br>In order to prevent leakage and damage of personal information by hacking or computer viruses, security programs are installed, periodic updates and inspections are performed, systems are installed in areas where access is controlled from outside, and technically/physically monitored and blocked.
  </li>
  <li>Access Restrictions to Personal Information
    <br>We take necessary measures to control access to personal information by granting, changing, and canceling access to database systems that process personal information, and use an intrusion prevention system to control unauthorized access from the outside.
  </li>
  <li>Storage of access records and prevention of forgery
    <br>We keep and manage records of accessing the personal information processing system for at least six months, and we use security functions to prevent forgery, theft, or loss of access records.
  </li>
  <li>access control for unauthorized persons
    <br> We have a separate physical storage place for the personal information system that stores personal information, and we have established and operated access control procedures for this.
  </li>
</ol>
<h2>Article 5 Right to refuse collection/use of personal information and disadvantages of refusal</h2>
<ol>
  <li>The data subject has the right to refuse consent to the collection and use of personal information. However, if consent is refused, there may be restrictions on the use of the service.
  </li>
  <li>
    Matters concerning the installation·operation of automatic personal information<br />
    The company uses 'cookie' to provide user authentication or customized services for the data subject. A cookie is a small amount of information that the website transmits to the user's computer browser to store basic setting information about the user's site. The data subject has the option to allow all cookies in the data subject's web browser, go through verification whenever cookies are stored, or refuse to save all cookies. However, if you refuse to save cookies, there may be restrictions on the use of the service.<br />
   [Note] Each browser you use depends on how you set up cookies in that browser.
  </li>
</ol>
<h2>Article 6 Destruction of personal information</h2>
<ol>
  <li>When the retention period of personal information has elapsed, or when the personal information becomes unnecessary, such as the achievement of the purpose of processing personal information, the abolition of the relevant service, the termination of the business, etc., the company shall destroy the personal information without delay. Provided, That where it is necessary to preserve it in accordance with relevant laws and internal policies, such as the Commercial Act, it shall not be destroyed.</li>
  <li>Written documents containing personal information shall be destroyed by shredding or incineration, and personal information in the form of electronic files shall be permanently deleted and destroyed in a way that cannot be restored.</li>
</ol>
<h2>Article 7 Rights and obligations of data subjects and legal representatives and methods of exercising them</h2>
<ol>
  <li>Access to personal information
    <br> The data subject can visit the company and request access to personal information, and respond quickly.
  </li>
  <li>
    Correction and deletion of personal information<br>
    If the data subject requests correction or deletion of personal information, or if it is deemed necessary to correct or delete personal information, such as if there is an error in the personal information, the company will immediately correct or delete it. For the accuracy of the processing, the company may request the data subject to provide evidence necessary for confirming the facts of the correction and deletion.
  </li>
  <li>How to exercise
    <ul>
      <li>If the data subject requests to view, correct, or delete personal information, the company will respond to the data subject's request in good faith and process it without delay. In order to strictly protect the data subject's personal information, the company does not provide procedures for viewing, correcting, or deleting the data subject's personal information through other methods of application, such as phone calls, mail, or fax, other than the data subject's visit.</li>
      <li>The information subject may view or modify his/her registered personal information at any time, and may request cancellation of membership (withdrawal of membership) if he/she does not agree to the company’s processing of personal information. However, if he/she cancels his/her membership, he/she may have difficulty using some or all of the company’s services. The information subject may directly view and modify his/her personal information in &quot;My Page - Modify Personal Information.&quot; Withdrawal of membership may be directly performed in &quot;My Page - Terms of Use.&quot;</li>
      <li>If the information subject requests correction and deletion of personal information, he or she will be presented with an identification certificate such as a resident registration card, passport, and driver's license that indicates the identity of the information subject.</li>
      <li>If the information subject requests correction and deletion of personal information, he or she will be presented with an identification certificate such as a resident registration card, passport, and driver's license that indicates the identity of the information subject.</li>
      <li>The company may reject the request of the data subject if there is a justifiable reason to reject the access, correction, or deletion of all or part of the personal information, such as when there is a special provision in the law or when it is inevitable to comply with legal obligations. In this case, the company will notify the data subject of this and inform them of the reason.</li>
    </ul>
  </li>
</ol>
<h2>Article 8 Personal Information Protection Manager</h2>
<ol>
  <li>The company is in charge of handling personal information and designates a person in charge of personal information protection as follows for the handling of complaints and damage relief of information subjects related to personal information processing.
    <ul>
      <li>Personal Information Protection Officer: Telenasindo Slamet
      <li>Personal Information Protection Department: Research and Development Planning Team
      <li>Phone: +62 822-4971-2380
      <li>Email: hh-planning@healthhub.kr
    </ul>
  </li>
  <li>If you have any questions, complaints, or requests for relief regarding personal information protection that arise while using the company's services, you may contact the personal information protection officer or the department in charge.</li>
</ol>
<h2>Article 9. Methods of relief for infringement of rights</h2>
<p>If you need to report or consult about a personal information infringement outside of the company, please contact the following organizations.</p>
<ul style="list-style: '▶';">
  <li>Personal Information Protection Portal (privacy.go.kr / 118 without area code)</li>
  <li>Korea Internet & Security Agency Personal Information Infringement Report Center (privacy.kisa.or.kr / 118 without area code)</li>
  <li>National Police Agency Cyber Investigation Bureau (ecrm.cyber.go.kr / 112, 182 without area code)</li>
</ul>
<h2>Article 10 Changes to personal information processing policy</h2>
<ol>
  <li>This personal information processing policy will take effect from the date of enforcement, and if there is any additional deletion or modification of changes in accordance with laws and policies, we will notify you seven days before the change takes effect.</li>
  <li>This Privacy Policy applies from 11 October 2024.</li>
  <li>
    You can check the previous privacy policy below.
    <ul>
      <li>Applies from 2024. 10. 01 to 2024. 10. 11 (<a href="https://www.hscan.kr/terms" target="_blank">Click</a>)</li>
    </ul>
  </li>
</ol>
  `,
  [Agreement.thirdPartyInformationSharing]: `
<meta name="viewport" content="width=device-width user-scalable=0 initial-scale=1.0 mximum-scale=1.0 minimum-scale=1.0">
<style>
ul, ol {
  padding-left: 2em;
}
ol ol ol {
  padding-left: 1em;
}
h1 {
  font-size: 20px;
}
h2 {
  font-size: 14px;
}
th, td, p, li {
  font-size: 12px;
}
table, th, td {
  border-collapse: collapse;
  border: 1px solid;
  vertical-align: baseline;
}
td {
  padding: 4px;
  box-sizing: border-box;
}
</style>
<ol>
  <li>
    제공받는자: 서비스 도입 의료기관<br />
    <ol>
      <li style="list-style: '1) ';">
        건양대학교병원, 케어네트워크 구축 사업 참여 의료기관<br />
        (www.carenetwork.kr)
      </li>
      <li style="list-style: '2) ';">
        제주대학교병원, 시법사업 참여 의료기관<br />
        (제주대학교병원)
      </li>
      <li style="list-style: '3) ';">
        서비스 도입 의료기관<br />
        (헬스허브)
      </li>
    </ol>
  </li>
  <li>
    제공 받는 자의 개인정보 이용 목적<br />
    <ol>
      <li style="list-style: '1) ';">
        제공 받은 의료정보를 진료 목적으로 활용
      </li>
      <li style="list-style: '2) ';">
        의료기관에서 의료정보로 취급하는 목적으로 활용
      </li>
    </ol>
  </li>
  <li>
    제공하는 개인정보의 항목<br />
    <ol>
      <li style="list-style: '1) ';">
        차트번호, 성명, 성별, 생년월일, 전화번호
      </li>
      <li style="list-style: '2) ';">
        의료영상
      </li>
    </ol>
  </li>
  <li>
    제공하는 개인정보 보유기간: 5년
  </li>
  <li>
    동의를 거부할 권리가 있으며,<br />
    단, 동의를 거부할시 의료영상 전송 등 서비스를 이용하 수 없습니다.
  </li>
</ol>
  `,
};
